import React, { useEffect, useState, useRef, useContext, useMemo, Fragment } from 'react';
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import $, { error } from 'jquery';
import * as Yup from 'yup';
/*import { yupResolver } from '@hookform/resolvers/yup';*/
import { CheckSession, FormatCurrency, GetCoockie, shopping_cart_session_id, DefaultImage, GetShoppingCart, UpdateShoppingCart, KImageURL, ValidateQty, GetSKUDetailGlb, IsTestDealer, generateSixDigitNumber, GetDomain, days } from "../../GlobalScript";
import { ShoppingCartContext } from '../ShoppingCartContext';
import { useReactToPrint } from 'react-to-print';
import Select from 'react-select';
import PrintableOrder from '../PrintableOrder.js';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import CloseButton from 'react-bootstrap/CloseButton';
import PulseLoader from "react-spinners/PulseLoader";
//import Cookies from 'js-cookie';
import ReviewOrder from './ReviewOrder.js';
import ItemInquiry from '../ItemInquiry.js';
import FooterDealer from '../../FooterDealer.js';
import FileUpload from '../FileUpload.js';
import useLocalStorage from "use-local-storage";
import { useTranslation, Trans } from 'react-i18next';
import Cookies from 'js-cookie';

export default function NewOrder() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [debouncedLoading, setDebouncedLoading] = useState(false);
    const [itemsLoad, setItemsLoad] = useState(false);
    const [changeLoad, setChangeLoad] = useState(false);
    const [itemInfoLoad, setItemInfoLoad] = useState(false);
    const [shipLoad, setShipLoad] = useState(false);
    const [OrderTypes, setOrderTypes] = useState(null);
    const [DefaultShipTo, setDefaultShipTo] = useState(null);
    const [OrderName, setOrderName] = useState('');
    const [partNum, setPartNum] = useState('');
    const [partQty, setPartQty] = useState('');
    // const [partMemo, setPartMemo] = useState('');
    const [ShipTo, setShipTo] = useState(null);
    const [Sku, setSku] = useState('');
    const [Qty, setQty] = useState(1);
    const [orderStep, setOrderStep] = useState(1);
    const [viewMode, setViewMode] = useState(1);
    const [initialLanding, setInitialLanding] = useState(true);
    const [selectMode, setSelectMode] = useState(true);
    const [selectAll, setSelectAll] = useState(false);
    const [checkedItems, setCheckedItems] = useState(new Set());
    const [cartSession, setCartSession] = useState(localStorage.getItem(shopping_cart_session_id));

    const [AccSubtotal, setAccSubtotal] = useState(0);
    const [ParSubtotal, setParSubtotal] = useState(0);
    const [OtherSubtotal, setOtherSubtotal] = useState(0);
    const [EstFreight, setEstFreight] = useState(0);
    const [EstHandling, setEstHandling] = useState(0);
    const [EstSpecialFee, setEstSpecialFee] = useState(0);
    const [SpecialDealerFeeText, setSpecialDealerFeeText] = useState(null);
    const [Total, setTotal] = useState(0);
    const [ShipMethod, setShipMethod] = useState('');
    const [submit, setSubmit] = useState(false);
    const [OrderID, setOrderID] = useState('');
    const [DealerIdInput, setDealerIdInput] = useState('');
    const [ShipToDealerID, setShipToDealerID] = useState('');
    const [runningTotal, setRunningTotal] = useState('');

    const [showDealerModal, setShowDealerModal] = useState(false);
    const [importDealerModal, setImportDealerModal] = useState(false);
    const [submitErrorMsg, setSubmitErrorMsg] = useState('');
    const [appliedKCode, setAppliedKCode] = useState('');
    const [separatedOrder, setSeparatedOrder] = useState(null);
    const [fromImport, setFromImport] = useState(false);
    const [uniqueDealer, setUniqueDealer] = useState(false);
    const [thirdParty, setThirdParty] = useState('');
    const [userInfo, setUserInfo] = useState(null);
    const [creditHold, setCreditHold] = useState(false);
    const [orderSaved, setOrderSaved] = useState(false);
    /*const [formatDropShip, setFormatDropShip] = useState([]);*/
    const [selectedDropShip, setSelectedDropShip] = useState('');
    const [formattedDealerAddresses, setFormattedDealerAddresses] = useState([]);
    const [allDealerAddresses, setAllDealerAddresses] = useState([]);
    const [dealersLoading, setDealersLoading] = useState(false);

    const [changedSKU, setChangedSKU] = useState(null);
    const [fromNonOrderFrom, setFromNonOrderFrom] = useState(null);

    const [selectedItems, setSelectedItems] = useState(new Map());
    const [showItemModal, setShowItemModal] = useState(false);
    //const [ValuesForItemInquiry, setValuesForItemInquiry] = useState(null);
    const [kCode, setKCode] = useState('');
    const [exchangeOrder, setExchangeOrder] = useState(true);
    const [localQty, setLocalQty] = useState({});
    const [lastValidQty, setLastValidQty] = useState({});
    const [pendingQtyChanges, setPendingQtyChanges] = useState({});

    const [alerts, setAlerts] = useState([]);
    const hasAlert = (type) => alerts?.some(alert => alert.type === type);

    const [ShipCodes, setShipCodes] = useState(null);
    const [ForwarderAddresses, setForwarderAddresses] = useState(new Map());
    const [SelectedForwarderAddress, setSelectedForwarderAddress] = useState(null);
    const [SelectedDropshipAddress, setSelectedDropshipAddress] = useState(null);
    const [ForwarderAdd, setForwarderAdd] = useState(null);
    const [DropShipAdd, setDropShipAdd] = useState(null);
    const [AllForwarderAddMap, setAllForwarderAddMap] = useState(null);
    const { shoppingCart, setShoppingCart, clearCart, getCookie, setDropdownOpen, setOrderType } = useContext(ShoppingCartContext);
    const cart = GetShoppingCart(shoppingCart);
    const [localSelectedOrderType, setLocalSelectedOrderType] = useState('');
    const [SelectedOrderType, setSelectedOrderType] = useState(cart ? cart.orderType : null);

    const isBulkImportItem = (element) =>
        typeof element?.rowKey === 'string' &&
        element.rowKey.startsWith('bulk_');

    const getSelectedItemKey = (element) => {
        if (isBulkImportItem(element)) {
            return element.rowKey;
        }

        const itemNumber = element?.item?.distitemNbr
            ?.replaceAll('-', '').toUpperCase() || '';
        const memo = element?.item?.vin || '';


        return itemNumber + (memo ? `|${memo}` : '');
    };

    const getRequestItemKey = (element) => {
        if (typeof element?.rowKey === 'string' &&
            element.rowKey.startsWith('bulk_')) {
            return element.rowKey;
        }

        const itemNumber = element?.sku?.replaceAll('-', '').toUpperCase() || '';
        const memo = element?.vin || '';

        return itemNumber + (memo ? `|${memo}` : '');
    };

    /* const [ItemForShoppingCart, setItemForShoppingCart] = useState(null);*/
    /*    const { ShoppingCartItems, setShoppingCartItems } = useContext(ShoppingCartContext);*/
    const [BulkLoad, setBulkLoad] = useState(null);
    //const [ShoppingCartSession, setShoppingCartSession] = useLocalStorage(shopping_cart_session_id, "");

    const [SelectedItemForModels, setSelectedItemForModels] = useState(null);
    const [Models, setModels] = useState(null);
    const [showModelModal, setShowModelModal] = useState(false);
    const [DealerChanged, setDealerChanged] = useState(false);
    const [ItemsNumberQtyArr, setItemsNumberQtyArr] = useState(null);
    const [UpdateMode, setUpdateMode] = useState(false);
    const [popUpModal, setPopUpModal] = useState(false);
    const [popUpErrorMsg, setPopUpMsg] = useState('');
    const [isPrinting, setIsPrinting] = useState(false);
    const [invalidKCodeSKUList, setInvalidKCodeSKUList] = useState(null);
    const [kCodeRadio, setKCodeRadio] = useState("1");

    const [manualDropShip, setManualDropShip] = useState(false);
    const [dropShipAddress, setDropShipAddress] = useState('');
    const [dropShipAddress2, setDropShipAddress2] = useState('');
    const [dropShipCrrName, setDropShipCrrName] = useState('');
    const [dropShipCity, setDropShipCity] = useState('');
    const [dropShipState, setDropShipState] = useState('');
    const [dropShipZipCode, setDropShipZipCode] = useState('');
    const [dropShipValidator, setDropShipValidator] = useState(false);
    const [stateOptions, setStateOptions] = useState([]);
    const [addItem, setAddItem] = useState(false);
    const [recallItem, setRecallItem] = useState(false);
    const { t } = useTranslation();
    const [standardPromoCodes, setStandardPromoCodes] = useState(null);
    const [extendedPromoCodes, setExtendedPromoCodes] = useState(null);
    const [isDealer, setIsDealer] = useState(true);
    const [waitMsg, setWaitMsg] = useState(false);
    //const [callAPI, setCallAPI] = useState(false);

    useEffect(() => {
        if (userInfo?.loginType !== 5) {
            document.title = 'K-Dealer - New Order';
        } else {
            document.title = 'K-Countries - New Order';
        }
        //Test();
    });

    const promiseResolveRef = useRef(null);
    const contentRef = useRef();

    useEffect(() => {
        if (isPrinting && promiseResolveRef.current) {
            promiseResolveRef.current();
        }
    }, [isPrinting])

    const handleModelModalShow = (itemNum) => {
        GetModels(itemNum);
        setShowModelModal(true);
    }

    const GetModels = async (itemnum) => {
        CheckSession();
        const response = await fetch("kdealer/GetModels/" + itemnum);
        if (response.status !== 200) {
            return;
        }
        const js = await response.json();
        const grouped = Object.groupBy(js.models, ({ year }) => year);
        const sortedGroups = Object.entries(grouped)
            .sort(([groupA], [groupB]) => groupB.localeCompare(groupA))
            .map(([group, models]) => {
                models.sort((a, b) => a.label - b.label);
                return { group, models };
            });
        setSelectedItemForModels({ itemNum: js.itemNum, itemName: js.itemName })
        console.log(sortedGroups);
        setModels(sortedGroups);
    }

    const handleModelModalClose = () => setShowModelModal(false);

    const controller = new AbortController();

    const timeoutId = setTimeout(() => {
        controller.abort();
    }, 30000);

    /*const [dropdownStates, setDropdownStates] = useState({});*/

    /*const [showMemo, setShowMemo] = useState({});*/

    //const toggleMemo = (id) => {
    //    setShowMemo(prev => ({
    //        ...prev,
    //        [id]: !prev[id]
    //    }));
    //}

    //const toggleDropdown = (itemId, isOpen) => {
    //    setDropdownStates((prev) => ({
    //        ...prev,
    //        [itemId]: isOpen,
    //    }));
    //};

    const [pop, setPop] = useState(false);
    const handlePop = () => setPop(true);
    const handleClosePop = () => setPop(false);

    const DEBOUNCE_DELAY = 300;
    const timeoutRef = useRef(null);

    useEffect(() => {
       try {
           const us = getCookie();
           if (!userInfo && us) {
               setUserInfo(us);
               window.GlobalLoading++;
           }
           fetchStates();
           if (window.GlobalLoading === 1) {
               window.location.reload();
           }

           // setShoppingCart(GetShoppingCart(shoppingCart));
       } catch (e) {
           console.log(e);
       }
    }, [userInfo])

    useEffect(() => {
        if (initialLanding) {
            GetUserPreferedViewMode();
            GetCurrentPromoCode();
            setInitialLanding(false);
        }
    }, [initialLanding]);

     useEffect(() => {
         if (UpdateMode === true && changedSKU && changedSKU.length > 0) {
             setItemInfoLoad(true);
             GetSKUDetail();
         }
     }, [UpdateMode, changedSKU]);

    useEffect(() => {
        if (loading) {
            handlePop();
        } else {
            handleClosePop();
        }
    }, [loading])

    useEffect(() => {
        if (cart && cart.kCode) {
            setKCode(cart.kCode);
        }
    }, [cart])

    //useEffect(() => {
    //    if (viewMode && !loading) {
    //        SaveUserPreferedViewMode();
    //    }
    //}, [viewMode])

    //useEffect(() => {
    //    clearTimeout(timeoutRef.current);

    //    if (loading) {
    //        timeoutRef.current = setTimeout(() => {
    //            setDebouncedLoading(false);
    //            setPopUpMsg('There was an issue connecting to the Kawasaki server. Please try again later');
    //            handlePopUpModalShow();
    //        }, 60000);
    //    } else {
    //        setDebouncedLoading(false);
    //    }

    //    return () => clearTimeout(timeoutRef.current);
    //}, [loading])

    useEffect(() => {
        setLoading(itemsLoad || changeLoad || itemInfoLoad || shipLoad);
    }, [itemsLoad, changeLoad, itemInfoLoad, shipLoad])

    //useEffect(() => {
    //    if (shoppingCart && shoppingCart.items.length !== selectedItems.size) {
    //        setItemsLoad(true);
    //    } else if (shoppingCart && shoppingCart.items.length === selectedItems.size) {
    //        setItemsLoad(false);
    //    }
    //}, [shoppingCart, selectedItems])

    useEffect(() => {
        if (shoppingCart && shoppingCart.items.length === selectedItems.size) {
            setItemsLoad(false);
        }
    }, [shoppingCart, selectedItems])

    const [SKUMemo, setSKUMemo] = useState(new Map());
    const [orderQty, setOrderQty] = useState(new Map());

    const handleDealerModalClose = () => {
        setShowDealerModal(false);
    }
    const handleDealerModalShow = () => {
        setShowDealerModal(true);
    };

    const ChangeDealer = async () => {
        handleDealerModalClose();
        if (DealerChanged) {
            setShipTo(DealerChanged);
            //setShipToDealerID(DealerIdInput);
            setShipToDealerID(DealerChanged.dealerID);
        }
    }

    const [showQtyModal, setShowQtyModal] = useState(false);
    const handleQtyModalShow = () => {
        setShowQtyModal(true);
    }

    const handleQtyModalClose = () => {
        setShowQtyModal(false);
    }

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleDeleteModalOpen = () => {
        setShowDeleteModal(true);
    }
    const handleDeleteModalClose = () => {
        setShowDeleteModal(false);
    }

    const handleImportModalClose = () => {
        setImportDealerModal(false);
    }
    const handleImportModalShow = () => {
        setImportDealerModal(true);
    }

    const importOrder = () => {
        handleImportModalClose();
    }

    const handleGoToStep2 = () => {
        if (userInfo?.loginType !== 5) {
            if ((localSelectedOrderType === null || localSelectedOrderType === '' || localSelectedOrderType === undefined) && (SelectedOrderType === null || SelectedOrderType === '' || SelectedOrderType === undefined)) {
                document.getElementById("SelectOrderType").classList.add("is-invalid");
            } else {
                document.getElementById("SelectOrderType").classList.remove("is-invalid");
                /*CheckOrderName(orderStep);*/
                setOrderStep(2);
                setUpdateMode(true);
                setSelectedOrderType(localSelectedOrderType);
            }
        } else {
            setLocalSelectedOrderType('1')
            setSelectedOrderType('1')
            setOrderStep(2);
            setUpdateMode(true);
        }
    }

    const ChangeShipMethod = async (value) => {
        if (value === "") {
            setShipMethod(null);
            return;
        }
        const user = GetCoockie();
        ShipCodes.forEach(element => {
            if (element.shipCode === value) {
                if (user.dealerID === "0336") {
                    setUniqueDealer(true);
                    if (element.actualCostInd === 2) {
                        setSpecialDealerFeeText('Discounted');
                    }
                    else if (element.actualCostInd === 3) {
                        setSpecialDealerFeeText('Published');
                    }
                }
                setEstFreight(element.estFreightCost);
                setEstHandling(element.estHandlingCharge);
                setEstSpecialFee(element.estSpecialFee);
                setShipMethod(value);
            }
        });
    }

    const ChangeForwarderAddress = async (value) => {
        setForwarderAdd(value);
    }
    const ChangeDropShipAddress = async (value) => {
        setDropShipAdd(value);

        const dropshipAddress = SelectedDropshipAddress.find(d => d.carrCode === value);
        setSelectedDropShip(dropshipAddress)
    }

    // useEffect(() => {
    //     if (ShipMethod && ForwarderAddresses && (ShipMethod.substring(0, 1) === "I" || SelectedOrderType === '4')) {
    //         GetForwarderDropshipAddress(ShipMethod);
    //     } else {
    //         setSelectedForwarderAddress(null);
    //         setSelectedDropshipAddress(null)
    //     }
    // }, [ShipMethod, ForwarderAddresses, SelectedOrderType])

    useEffect(() => {
        if (ShipMethod && ForwarderAddresses && (ShipMethod.substring(0, 1) === "I" || SelectedOrderType === '4')) {
            GetForwarderDropshipAddress(ShipMethod);
        } else {
            setSelectedForwarderAddress(null);
            setSelectedDropshipAddress(null)
        }
    }, [ShipMethod, ForwarderAddresses])

    useEffect(() => {
        if (SelectedOrderType !== null && SelectedOrderType !== '') {
            setLocalSelectedOrderType(SelectedOrderType);
        }
    }, [SelectedOrderType])

    const ChangeOrderType = async (e) => {
        setLocalSelectedOrderType(e.target.value)
        //setSelectedOrderType(e.target.value);
        //setUpdateMode(true);
    }

    const handleItemModalShow = () => {
        //let arr = [];
        //Array.from(selectedItems.values()).forEach(element => {
        //    arr.push({ sku: element.item.distitemNbr, qty: element.item.qty });
        //});
        //setValuesForItemInquiry(arr);
        setShowItemModal(true);
    }

    const handleItemModalClose = () => {
        setShowItemModal(false);
        setFromImport(false);
    };

    useEffect(() => {
        if (selectedItems.size === 0) {
            setSelectAll(false);
            setCheckedItems(new Set());
            if (!SelectedOrderType || SelectedOrderType === '') {
                setOrderStep(1);
            }
        }

        if (selectedItems.size > 0 && orderStep === 1 && localSelectedOrderType !== '') {
            handleGoToStep2();
        }

        if (selectedItems.size >= 25) {
            setViewMode(2);
        }

        if (selectedItems.size > 0 && kCode) {
            handleAddKCode();
        }
        const total = Array.from(selectedItems.values()).reduce((sum, d) => {
            const price = d.item.dealerPrice || 0;
            const qty = d.item.qty || 0;
            const boCnt = d.item.boCnt || 0;
            return sum + price * (qty + boCnt);
        }, 0);
        setRunningTotal(total);
    }, [selectedItems, localSelectedOrderType])

    useEffect(() => {
        if (orderStep === 3 && !submit) {
            document.getElementById("step-2-start").scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
    }, [orderStep])

    useEffect(() => {
        if (shoppingCart?.items?.length > 0) {
            const quantities = {};

            shoppingCart.items.forEach(element => {
                if (element.item.qtyOrdered > 0) {
                    const cleanID = (element.item.distitemNbr.replaceAll('-', '') + (element.item.vin === '' ? '' : ('|' + element.item.vin))).toUpperCase();
                    quantities[cleanID] = element.item.qtyOrdered;
                }
            });

            setLocalQty(quantities);
            setLastValidQty(quantities);
        }
    }, [shoppingCart]);

    const handleBulkImportSelectedItems = ({ items, alerts }) => {
        const mergedItems = [];
        const itemsByPartNumber = new Map();
        [...(cart?.items || []), ...items].forEach(element => {
            const item = element.item;
            const partNumber = item.distitemNbr.replaceAll('-', '').trim().toUpperCase();
            if ((item.vin || '').trim() !== '' || partNumber === '') {
                mergedItems.push(element);
                return;
            }
            const existingItem = itemsByPartNumber.get(partNumber);
            if (!existingItem) {
                const itemCopy = { ...element, item: { ...item } };
                itemsByPartNumber.set(partNumber, itemCopy);
                mergedItems.push(itemCopy);
                return;
            }
            existingItem.item.qtyOrdered = (Number(existingItem.item.qtyOrdered) || 0) + (Number(item.qtyOrdered) || 0);
            existingItem.item.qty = (Number(existingItem.item.qty) || 0) + (Number(item.qty) || 0);
            existingItem.item.boCnt = (Number(existingItem.item.boCnt) || 0) + (Number(item.boCnt) || 0);
        });
        // The merged list already includes the existing cart.
        handleSelectedItems({ items: mergedItems, alerts: alerts }, true);
    };

    const handleSelectedItems = ({ items, alerts }, updateQty) => {
        /*setItemsLoad(true);*/
        const crrMap = new Map();
        //const arr = [];
        /*const cart = GetShoppingCart();*/
        let acctotal = 0;
        let parttotal = 0;
        let othertotal = 0;
        const skuqty = [];
        const quantities = {};
        const subsMap = new Map();
        const errorItemSet = new Set();
        let newCartItems = [];
        items.forEach(element => {
            const itmNum = element.item.distitemNbr.replaceAll('-', '').toUpperCase();
            const itemKey = getSelectedItemKey(element);
            if (element.item.qtyOrdered > 0 && (element.item.itemStaCode === "1" || element.item.itemStaCode === "2")) {
                crrMap.set(itemKey, element);
                const qty = element.item.qty + element.item.boCnt;
                if (element.item.inventoryType === "A") {
                    parttotal += qty * element.item.dealerPrice;
                } else if (element.item.inventoryType === "B") {
                    acctotal += qty * element.item.dealerPrice;
                } else {
                    othertotal += qty * element.item.dealerPrice;
                }
                skuqty.push({
                    sku: element.item.distitemNbr,
                    qty: element.item.qtyOrdered,
                    vin: element.item.vin,
                    ...(isBulkImportItem(element)
                        ? { rowKey: element.rowKey }
                        : {})
                });
                if (element.item.substitutedSKU !== '') {
                    subsMap.set(element.item.substitutedSKU.replaceAll('-', '').toUpperCase(), itmNum);
                }
                quantities[itemKey] = element.item.qtyOrdered;
                newCartItems.push(element);
            }
            if (element.item.itemStaCode !== "1" && element.item.itemStaCode !== "2") {
                errorItemSet.add(
                    isBulkImportItem(element) ? itemKey : itmNum
                );
            }

        });

        /*setLocalQty(quantities);*/

        if (updateQty === false && cart && cart.items) {
            cart.items.forEach(element => {
                let itmNum = element.item.distitemNbr.replaceAll('-', '').toUpperCase();
                const newID = getSelectedItemKey(element);

                if (!isBulkImportItem(element) && subsMap.has(itmNum)) {
                    const originalItem = subsMap.get(itmNum);
                    const cleanID = originalItem + (!element.item.vin ? '' : ('|' + element.item.vin));
                    if (crrMap.has(cleanID) && element.item.qtyOrdered > 0) {
                        let vl = crrMap.get(cleanID);
                        if (vl.item.vin === '' && vl.item.vin !== element.item.vin) {
                            vl.item.vin = element.item.vin;
                            crrMap.set(originalItem, vl);
                        }
                    }
                    return;
                }
                const errorItemKey = isBulkImportItem(element)
                    ? newID
                    : itmNum;
                if (!crrMap.has(newID) && element.item.qtyOrdered > 0 && (element.item.itemStaCode === "1" || element.item.itemStaCode === "2") && !errorItemSet.has(errorItemKey)) {
                    crrMap.set(newID, element);
                    const qty = element.item.qty + element.item.boCnt;
                    if (element.item.inventoryType === "A") {
                        parttotal += qty * element.item.dealerPrice;
                    } else if (element.item.inventoryType === "B") {
                        acctotal += qty * element.item.dealerPrice;
                    } else {
                        othertotal += qty * element.item.dealerPrice;
                    }
                    //arr.push(element);
                    skuqty.push({
                        sku: element.item.distitemNbr,
                        qty: element.item.qtyOrdered,
                        vin: element.item.vin,
                        ...(isBulkImportItem(element)
                            ? { rowKey: element.rowKey }
                            : {})
                    });
                    newCartItems.push(element);
                }
                //else if (crrMap.has(newID) && element.item.qtyOrdered > 0){
                //    let vl = crrMap.get(newID);
                //    if (vl.item.memo === '' && vl.item.memo !== element.item.memo) {
                //        vl.item.memo = element.item.memo;
                //        crrMap.set(itmNum, vl);
                //    }
                //}

            });
        }

        setItemsNumberQtyArr(skuqty);

        setSelectedItems(crrMap);
        setAccSubtotal(acctotal);
        setParSubtotal(parttotal);
        setOtherSubtotal(othertotal);
        //setValuesForItemInquiry(arr);
        //let newCartItems = items;
        //if (arr.length > 0) {
        //    newCartItems.push(...arr);
        //}
        let oName = OrderName ?? '';

        if (oName.trim() === '') {
            oName = generateSixDigitNumber();
        }
        if (!ShipToDealerID) {
            LoadShipTo();
        }
        const newCart = {
            alerts: alerts,
            items: newCartItems,
            orderName: OrderName ?? '',
            orderType: SelectedOrderType,
            shipToDealerID: ShipToDealerID,
            kCode: (cart && cart.kCode) ?? '',
            fromVIPortal: (cart && cart.fromVIPortal) ?? false,
            callAPI: false
        }
        UpdateShoppingCart(newCart, setShoppingCart);
        setItemsLoad(false);
        setBulkLoad(null);
        setAlerts(alerts);
        setUpdateMode(false);
    };

    //useEffect(() => {
    //    if (!SelectedOrderType || SelectedOrderType === '') {
    //        setChangeLoad(false);
    //        return;
    //    }
    //    setChangeLoad(false);
    //    setUpdateMode(true);
    //    GetSKUDetail();
    //    LoadShipMethods();
    //}, [ItemsNumberQtyArr, ShipToDealerID, SelectedOrderType])
    const Test = async() => {
        CheckSession();
        const user = GetCoockie();
        const data = {
            orderIDSES: 'KDL000190',
            orderIDKMC: '',
            creditHold: false,
            orderName: '537134',
            dealerID: user.dealerID,
            userKey: user.userKey
        }
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(data)
        };
        const response = await fetch("kdealer/GetOrderStatus", requestOptions);
        if (response.status !== 200) {
            return;
        }
    };

    //check here
    useEffect(() => {
        if (!SelectedOrderType || SelectedOrderType === '') {
            setChangeLoad(false);
            return;
        }
        console.log('changed SKU triggered')
        console.log(changedSKU)
        setChangeLoad(false);
        setUpdateMode(true);
        if (fromNonOrderFrom === true && orderStep === 1) {
            GetSKUDetail();
            handleGoToStep2();
        }
        //LoadShipMethods();
    }, [changedSKU])

    // useEffect(() => {
    //     if (!SelectedOrderType || SelectedOrderType === '') {
    //         setChangeLoad(false);
    //         return;
    //     }

    //     if (callAPI === true) {
    //         GetSKUDetail();
    //     }
    // }, [callAPI])

    useEffect(() => {
        if (!SelectedOrderType || SelectedOrderType === '') {
            setChangeLoad(false);
            return;
        }

        if (orderStep === 3) {
            getDealerShipInfo();
            LoadShipMethods();
            //GetSKUDetail();
        }
    }, [orderStep, ShipToDealerID])

    // useEffect(() => {
    //     if (!SelectedOrderType || SelectedOrderType === '') {
    //         setChangeLoad(false);
    //         setOrderStep(1);
    //         return;
    //     }

    //     //add code to update changedSKU
    //     if (orderStep > 1) {
    //         const skuObjs = [];
    //         selectedItems.forEach((value, key) => {
    //             skuObjs.push({
    //                 sku: value.item.distitemNbr,
    //                 qty: value.item.qtyOrdered,
    //                 vin: value.item.vin,
    //                 ...(isBulkImportItem(value)
    //                     ? { rowKey: key }
    //                     : {})
    //             });
    //         });
    //         //GetSKUDetail();
    //         setUpdateMode(true);
    //         setChangedSKU(skuObjs);
    //     }

    //     if (cart && SelectedOrderType !== cart.orderType) {
    //         // const map = new Map(selectedItems);
    //         // const newCartItems = Array.from(map.values());
    //         const newCart = {
    //             alerts: cart.alerts,
    //             items: cart.items,
    //             orderName: cart.orderName,
    //             orderType: SelectedOrderType,
    //             shipToDealerID: cart.shipToDealerID,
    //             kCode: cart.kCode ?? '',
    //             fromVIPortal: (cart && cart.fromVIPortal) ?? false
    //         }
    //         UpdateShoppingCart(newCart, setShoppingCart);
    //     } else if(!cart){
    //         const newCart = {
    //             alerts: [],
    //             items: [],
    //             orderName: OrderName,
    //             orderType: SelectedOrderType,
    //             shipToDealerID: ShipToDealerID,
    //             kCode:  '',
    //             fromVIPortal: false
    //         }
    //         UpdateShoppingCart(newCart, setShoppingCart);
    //     }
    //     //setCallAPI(true);
    //     //GetSKUDetail();
    //     setUpdateMode(true);
    // }, [SelectedOrderType])

    // useEffect(() => {
    //     SaveOrderIntoTempTable(ItemsNumberQtyArr, 2);
    // }, [ItemsNumberQtyArr])

    const handleSelectionChange = (e, data) => {

    };

    const handlePopUpModalShow = () => {
        setPopUpModal(true);
    }
    const handlePopUpModalClose = () => {
        setPopUpModal(false);
        setPopUpMsg('');
        if (invalidKCodeSKUList) {
            setInvalidKCodeSKUList(null);
        }
        if (kCodeRadio) {
            setKCodeRadio("1");
        }
        if (recallItem) {
            setRecallItem(false);
        }
    }

    const SaveOrder = () => {
        // if (invalidKCodeSKUList && invalidKCodeSKUList.length > 0) {
        //     const arr = [];
        //     invalidKCodeSKUList.forEach(function (element) {
        //         const itemNum = element;
        //         //if (selectAllItems.has())
        //     });
        //     //if (SaveOrderIntoTempTable(arr, 1)) {
        //     //    setPopUpMsg('Your order has been saved.');
        //     //    handlePopUpModalShow();
        //     //} else {
        //     //    setPopUpMsg('There was an error in saving your order. Please try again later');
        //     //    handlePopUpModalShow();
        //     //}
        // }

        if (ItemsNumberQtyArr) {
            SaveOrderIntoTempTable(ItemsNumberQtyArr, 1);

            setPopUpMsg('Your order has been saved.');
            handlePopUpModalShow();
        } else {
            setPopUpMsg('Please add items to your order before saving.');
            handlePopUpModalShow();
        }
    };

    const SaveOrderIntoTempTable = async (skuqty, ordStatus) => {
        try {
            CheckSession();
            const user = GetCoockie();

            //if (!ItemsNumberQtyArr || ItemsNumberQtyArr.length === 0 || !SelectedOrderType || !ShipToDealerID) {
            //    return;
            //}
            if (!skuqty || skuqty.length === 0 || !SelectedOrderType || SelectedOrderType === '' || !ShipToDealerID) {
                return;
            }
            const data = {
                valueLabels: skuqty.map(element => ({
                    sku: element.sku,
                    qty: element.qty,
                    vin: element.vin
                })),
                orderType: SelectedOrderType,
                userKey: user.userKey,
                shipToDealerID: ShipToDealerID,
                dealerID: user.dealerID,
                orderName: OrderName ? OrderName : '',
                buyerCookie: user.buyerCookie,
                status: ordStatus,//1->saved 2-incomplete,
                kCode: kCode
            };
            const rqst = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const res = await fetch('kdealer/SaveOrder/', rqst);
            if (res.status !== 200) {
                throw new Error(res.statusText);
            }
            if (ordStatus === 1) {
                const key = await res.text();
                setSeparatedOrder(key);
            }
            return true;
        } catch (e) {
            console.log(e);
            return false;
        }
    }

    const GetUserPreferedViewMode = async () => {
        try {
            CheckSession();
            const user = GetCoockie();
            const data = {
                value: user.userKey.toString(),
                label: user.dealerID,
            };
            const rqst = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const res = await fetch('kdealer/GetOrderViewMode/', rqst);
            if (res.status === 200) {
                const view = await res.text();
                setViewMode(parseInt(view));
            } else {
                setViewMode(1);
            }
            return true;
        } catch (e) {
            console.log(e);
            return false;
        }
    }

    const SaveUserPreferedViewMode = async (mode) => {
        try {
            CheckSession();
            const user = GetCoockie();
            const data = {
                userKey: user.userKey,
                dealerID: user.dealerID,
                mode: mode
            };
            const rqst = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const res = await fetch('kdealer/SaveOrderViewMode/', rqst);
            if (res.status !== 200) {
                throw new error("Cannot get view mode");
            }
            return true;
        } catch (e) {
            console.log(e);
            return false;
        }
    }

    const GetCurrentPromoCode = async (mode) => {
        try {
            CheckSession();
            const user = GetCoockie();
            const data = {
                label: user.userKey.toString(),
                value: user.dealerID,
            };
            const rqst = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const res = await fetch('kdealer/GetCurrentPromoCode/', rqst);
            if (res.status !== 200) {
                throw new error("Cannot get promo code");
            }
            const js = await res.json();
            // Filter for strings ending in 'C'
            const endsWithC = js.filter(str => str.endsWith('C'));

            // Filter for strings ending in 'T'
            const endsWithT = js.filter(str => str.endsWith('T'));
            setStandardPromoCodes(endsWithC);
            setExtendedPromoCodes(endsWithT);
        } catch (e) {
            console.log(e);
            return false;
        }
    }

    //check here
    const GetSKUDetail = async () => {
        console.log('SKU function running')
        const newSkuQty = [];
        let errorMsg = '';
        let errorSet = new Set();

        try {
            //single update
            if (!SelectedOrderType || SelectedOrderType === '' || !changedSKU || changedSKU.length === 0) {
                console.log('exit here 2')
                return;
            }
            if (UpdateMode === false) {
                setItemsLoad(false);
                console.log('exit here 1')
                return;
            }
            CheckSession();
            const user = GetCoockie();

            // for (const skuqtymemo of changedSKU) {
            //     const cleanID = skuqtymemo.sku.replaceAll('-', '') + (skuqtymemo.vin === '' ? '' : ('|' + skuqtymemo.vin));
            //     if (localQty[cleanID] && localQty[cleanID] !== skuqtymemo.qty) {
            //         skuqtymemo.qty += localQty[cleanID];
            //     }
            // }
            const skuqty = {
                valueLabels: changedSKU.map(element => ({
                    sku: element.sku,
                    qty: element.qty,
                    vin: element.vin
                })),
                orderType: SelectedOrderType,
                dealerID: user.dealerID,
                userKey: user.userKey
            };
            const rqst = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(skuqty)
            };

            const res = await fetch('kdealer/GetSkuInfo/', rqst);

            //const res = await fetch('kdealer/GetSkuInfo/',
            //    {
            //        ...rqst,
            //        signal: controller.signal
            //    }
            //);

            //clearTimeout(timeoutId);

            if (res.status !== 200) {
                throw new Error(res.statusText);
            }

            const js = await res.json();
            const addInfo = new Map();
            const bulkRowKeyQueues = new Map();

            changedSKU.forEach(element => {
                if (typeof element?.rowKey !== 'string' ||
                    !element.rowKey.startsWith('bulk_')) {
                    return;
                }

                const requestKey =
                    (element.sku?.replaceAll('-', '').toUpperCase() || '') +
                    `|${element.vin || ''}`;
                const queue = bulkRowKeyQueues.get(requestKey) || [];
                queue.push(element.rowKey);
                bulkRowKeyQueues.set(requestKey, queue);
            });

            const responseRowKeys = js.map(item => {
                const itemNumbers = [
                    item.distitemNbr,
                    item.substitutedSKU
                ].filter(Boolean);

                for (const itemNumber of itemNumbers) {
                    const requestKey =
                        itemNumber.replaceAll('-', '').toUpperCase() +
                        `|${item.vin || ''}`;
                    const queue = bulkRowKeyQueues.get(requestKey);

                    if (queue && queue.length > 0) {
                        return queue.shift();
                    }
                }

                return null;
            });

            const arrSubs = [];
            let alertFactor = 0, boCount = 0;
            let LTL = false;
            let pk = false;
            console.log(js);
            js.map((item, index) => {
                setIsDealer(item.isDealer);
                if (item.distitemNbr !== "") {
                    if ((addItem === true || (cart && cart.fromVIPortal === false)) && (item.recallItemCode === "QR" || item.recallItemCode === "QV")) {
                        item.errorMsg = `${item.distitemNbr}: To order this recall part, this transaction must be started from the Vehicle Information Portal`;
                        setPopUpMsg('To order this recall part, this transaction must be started from the Vehicle Information Portal');
                    }

                    //let bypassRecallItemQtyErrorCheck = false;
                    //if (item.recallItemCode === "QR" || item.recallItemCode === "QV") {
                    //    item.qtyOrdered = 1;
                    //    item.qty = 1;
                    //    bypassRecallItemQtyErrorCheck = true;
                    //}

                    if (item.errorMsg !== "") {
                        if (item.errorMsg.toLowerCase().indexOf("invalid") > -1) {
                            errorSet.add("At least one Item Number is invalid.");
                        } else {
                            errorSet.add(item.errorMsg);
                        }
                        errorMsg += item.errorMsg;
                    } else if (item.qtyOrdered > 0) {

                        newSkuQty.push({
                            sku: item.distitemNbr,
                            qty: item.qtyOrdered,
                            vin: item.vin
                        }
                        );
                        if (item.substitutedSKU !== "") {
                            arrSubs.push(`${item.substitutedSKU} is substituted by ${item.distitemNbr}`);
                        }
                        if (item.factorAlert) {
                            alertFactor++;
                        }
                        if (item.boCnt > 0) {
                            boCount++;
                        }
                        if (item.ltl === true) {
                            LTL = true;
                        }
                        if (item.pk === true) {
                            pk = true;
                        }
                        const cleanID = responseRowKeys[index] ||
                            item.distitemNbr.replaceAll('-', '').toUpperCase() +
                            (item.vin === '' ? '' : ('|' + item.vin));
                        if (localQty[cleanID] && localQty[cleanID] !== item.qty) {
                            localQty[cleanID] = item.qty;
                            localQty[cleanID] = item.qty;
                            item.qtyOrdered = item.qty + item.boCnt;
                        }
                        //updateQuantity(id, vl, true);
                    }
                } else if (item.errorMsg.toLowerCase().indexOf("invalid") > -1) {
                    errorSet.add("At least one Item Number is invalid.");
                    setPopUpMsg(t('notice.invalidPartNumber'));
                    handlePopUpModalShow();
                } else if (item.errorMsg) {
                    errorSet.add(item.errorMsg);
                    setPopUpMsg(item.errorMsg);
                    handlePopUpModalShow();
                }
                console.log('exit here 3')
                return '';
            });

            setAddItem(false);
            if (newSkuQty.length === 0) {
                setItemsLoad(false);
                if (cart && changedSKU.length > 0 && newSkuQty.length === 0) {
                    const newItems = [];
                    cart.items.forEach(element => {
                        const itmNum = element.item.distitemNbr.replaceAll('-', '').toUpperCase();
                        const failedItemKey = getRequestItemKey(
                            changedSKU[0]
                        );
                        const currentItemKey = getSelectedItemKey(element);
                        const keepItem = changedSKU[0]?.rowKey
                            ? currentItemKey !== failedItemKey
                            : itmNum !== changedSKU[0].sku.replaceAll('-', '').toUpperCase();

                        if (keepItem) {
                            newItems.push(element)
                        }
                    });
                    if (newItems.length === 0) {
                        UpdateShoppingCart(null, setShoppingCart);
                        console.log('null cart')
                    } else {
                        cart.items = newItems;
                        UpdateShoppingCart(cart, setShoppingCart);
                        console.log('updated cart')
                    }
                }

                if (res.status === 200 && js.length === 0) {
                    setPopUpMsg('The item number you have entered is invalid. Please try a different item number.');
                    handlePopUpModalShow();
                } else if (js.length === 0) {
                    setPopUpMsg('There was an error while attempting to connect to the Kawasaki server. Please try again later.');
                    handlePopUpModalShow();
                }
                console.log('exit here 4')
                return;
            }
            //Item Number
            const skuqty2 = {
                valueLabels: newSkuQty,
                orderType: SelectedOrderType,
                dealerID: user.dealerID,
                userKey: user.userKey
            };
            const rqst2 = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(skuqty2)
            };
            const res2 = await fetch('kdealer/GetSkuInfo2/', rqst2);
            if (res2.status !== 200) {
                throw new Error(res.statusText);
            }
            const js2 = await res2.json();

            js2.map((item) => {
                if (item.itemStaCode === "1" || item.itemStaCode === "2") {
                    addInfo.set(item.itemNumber.replaceAll('-', '').toUpperCase(), item);
                }
                console.log('exit here 5')
                return '';
            });

            let skuObjs = [];
            const set = new Set();
            js.map((item, index) => {
                const itm = item.distitemNbr.replaceAll('-', '').toUpperCase();
                //if (itm !== "" && item.errorMsg === '') {
                if (itm !== "") {
                    const info = {
                        item: item,
                        addInfo: addInfo.get(itm),
                        ...(responseRowKeys[index]
                            ? { rowKey: responseRowKeys[index] }
                            : {})
                    }
                    set.add(itm);
                    skuObjs.push(info);
                }
                console.log('exit here 6')
                return '';
            });

            selectedItems.forEach((value, key) => {
                const cleanItemNum = value.item.distitemNbr.replaceAll('-', '').toUpperCase();
                if (!set.has(cleanItemNum)) {
                    if (cleanItemNum !== "") {
                        skuObjs.push(value);
                    }
                    if (value.item.errorMsg !== "") {
                        if (value.item.errorMsg.toLowerCase().indexOf("invalid") > -1) {
                            errorSet.add("At least one Item Number is invalid.");
                        } else {
                            errorSet.add(value.item.errorMsg);
                        }

                    } else {
                        //skuObjs.push(value);
                        if (cleanItemNum !== "") {
                            if (value.item.qtyOrdered > 0) {
                                newSkuQty.push({
                                    sku: value.item.distitemNbr,
                                    qty: value.item.qtyOrdered,
                                    vin: value.item.vin
                                }
                                );
                                if (value.item.substitutedSKU !== "") {
                                    arrSubs.push(`${value.item.substitutedSKU} is substituted by ${value.item.distitemNbr}`);
                                }
                                if (value.item.factorAlert) {
                                    alertFactor++;
                                }
                                if (value.item.boCnt > 0) {
                                    boCount++;
                                }
                                if (value.item.ltl === true) {
                                    LTL = true;
                                }
                                if (value.item.pk === true) {
                                    pk = true;
                                }
                            }

                        }
                    }
                    console.log('exit here 7')
                    return '';
                }
            });

            const alerts = [
                alertFactor > 0 && { type: 'packQuantity' },
                boCount > 0 && { type: 'backorder' },
                LTL && { type: 'ltlShipping' },
                pk && { type: 'packageBuilt' },
                arrSubs.length > 0 && { type: 'substitutions' }
            ].filter(Boolean);
            setFromNonOrderFrom(false);
            if (ItemsNumberQtyArr) {
                SaveOrderIntoTempTable(ItemsNumberQtyArr, 2);
            }
            //setCallAPI(false);
            handleSelectedItems({ items: skuObjs, alerts: alerts }, false);
            console.log('we got here')
        } catch (e) {
            console.log(e);
            setItemsLoad(false);

            if (e.name === 'AbortError') {
                setPopUpMsg('The Kawasaki server is taking longer than expected to respond. Please try again later.');
                handlePopUpModalShow();
                return;
            }

            setPopUpMsg('There was an issue connecting to the Kawasaki server. Please try again later');
            handlePopUpModalShow();
        } finally {
            setItemInfoLoad(false);
            if (errorMsg !== '' && changedSKU.length === 1) {
                //show error pop-up
                if (errorMsg.indexOf("recall part") > 0) {
                    setRecallItem(true);
                    setPopUpMsg(errorMsg);
                } else if (errorSet.size > 0) {
                    setPopUpMsg(errorMsg);
                } else {
                    setPopUpMsg('The selected SKU is not available. Please enter a different SKU.');
                }
                handlePopUpModalShow();
            }
        }
    }

    const getDealerShipInfo = async () => {
        try {
            setDealersLoading(true);
            CheckSession();
            const user = GetCoockie();
            const data = {
                label: user.dealerID,
                value: '',
            };
            const rqst = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch('kdealer/GetDealerList/', rqst);

            if (response.status !== 200) {
                console.log('Error - not 200')
                return;
            }

            const adds = await response.json();

            if (adds) {
                setAllDealerAddresses(adds);

                const dealerAddressOptions = adds.map(item => ({
                    value: item.dealerID,
                    label: `${item.firstName}`
                }));

                setFormattedDealerAddresses(dealerAddressOptions);
            }
        } catch (e) {
            console.log(e);
            return;
        } finally {
            setDealersLoading(false);
        }
    }

    const GetForwarderDropshipAddress = async (val) => {
        if (val === "I4" || val === "I5" || val === "I6") {
            setSelectedDropshipAddress(ForwarderAddresses.get('D'));
            setSelectedForwarderAddress(null);
        } else if (val === "I7" || val === "I8") {
            setSelectedForwarderAddress(ForwarderAddresses.get('F'));
            setSelectedDropshipAddress(ForwarderAddresses.get('D'));
        } else if (SelectedOrderType === "4") {
            setSelectedDropshipAddress(ForwarderAddresses.get('C'));
        } else {
            setSelectedForwarderAddress(null);
            setSelectedDropshipAddress(null)
        }
    }

    const formatDropShip = useMemo(() => {
        if (!SelectedDropshipAddress) return [];

        return SelectedDropshipAddress.map(item => ({
            value: item.carrCode,
            label: `${item.crrName} ${item.add} ${item.city} ${item.stateCode} ${item.zip}`
        }));
    }, [SelectedDropshipAddress]);

    //useEffect(() => {
    //    if (SelectedDropshipAddress) {
    //        console.time("map");
    //        const dropShipOptions = SelectedDropshipAddress.slice(0, 100).map(item => ({
    //            value: item.carrCode,
    //            label: `${item.crrName} ${item.add} ${item.city} ${item.stateCode} ${item.zip}`
    //        }));
    //        console.timeEnd("map");

    //        setFormatDropShip(dropShipOptions);
    //    }
    //}, [SelectedDropshipAddress])

    //useEffect(() => {
    //    if (SelectedOrderType === "4" && orderStep === 3) {
    //        if (!SelectedDropshipAddress) {
    //            setLoading(true);
    //        } else {
    //            setLoading(false);
    //        }
    //    }
    //}, [SelectedDropshipAddress])

    const DeleteSelectedItems = () => {
        try {
            handlePop();
            const crrMap = new Map(selectedItems);
            let count = 0;

            const normalizedCheckedItems = new Set(
                Array.from(checkedItems).map(id => id.replace(/-/g, ""))
            );

            for (const id of normalizedCheckedItems) {
                if (crrMap.has(id)) {
                    crrMap.delete(id);
                    count++;
                }
            }

            if (selectAll) {
                setSelectedItems(new Map());
                clearCart();
            } else if (count > 0) {
                setSelectedItems(crrMap);
                const valuesArray = Array.from(crrMap.values());

                const newCart = {
                    alerts: [],
                    items: valuesArray,
                    orderType: SelectedOrderType,
                    shipToDealerID: ShipToDealerID,
                    orderName: OrderName,
                    kCode: (cart && cart.kCode) ?? '',
                    fromVIPortal: (cart && cart.fromVIPortal) ?? false
                }
                UpdateShoppingCart(newCart, setShoppingCart);
                /*$(':checkbox').prop('checked', false);*/
                UpdateSKUQty(crrMap);
                //setUpdateMode(true);
            }
        } catch (e) {
            console.log(e);
        } finally {
            handleClosePop();
            handleDeleteModalClose();
        }
    }

    const UpdateSKUQty = (crrMap) => {
        const skuqty = [];
        for (const [key, value] of crrMap.entries()) {
            if (value.item.qtyOrdered > 0) {
                skuqty.push({
                    sku: value.item.distitemNbr,
                    qty: value.item.qtyOrdered,
                    vin: value.item.vin,
                    ...(isBulkImportItem(value)
                        ? { rowKey: key }
                        : {})
                });
            }

        }
        setItemsNumberQtyArr(skuqty);
    }

    const LoadOrderType = async () => {
        try {
            CheckSession();
            const user = GetCoockie();
            const data = {
                label: user.email,
                value: user.dealerID
            };
            const rqst = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch('kdealer/GetOrderType/', rqst);
            if (response.status !== 200) {
                throw new Error(response.statusText);
            }
            //const img = await res.text();          
            //const response = await fetch("kdealer/GetOrderType");
            //if (response.status !== 200) {
            //    return;
            //}
            const ordType = await response.json();
            setOrderTypes(ordType);
            /*setSelectedOrderType(GetCartType());*/
        } catch (e) {
            console.log(e);
            return;
        }
    }

    useEffect(() => {
        if (SelectedOrderType) {
            if (cart && SelectedOrderType !== cart.orderType) {
                // const map = new Map(selectedItems);
                // const newCartItems = Array.from(map.values());
                const newCart = {
                    alerts: cart.alerts,
                    items: cart.items,
                    orderName: cart.orderName,
                    orderType: SelectedOrderType,
                    shipToDealerID: cart.shipToDealerID,
                    kCode: cart.kCode ?? '',
                    fromVIPortal: (cart && cart.fromVIPortal) ?? false
                }
                UpdateShoppingCart(newCart, setShoppingCart);
            } else if (!cart) {
                const newCart = {
                    alerts: [],
                    items: [],
                    orderName: OrderName,
                    orderType: SelectedOrderType,
                    shipToDealerID: ShipToDealerID,
                    kCode: '',
                    fromVIPortal: false
                }
                UpdateShoppingCart(newCart, setShoppingCart);
            }
        }
    }, [SelectedOrderType])

    const GetCartType = () => {
        CheckSession();
        /*const cart = GetShoppingCart();*/
        if (OrderTypes && OrderTypes.length > 0) {
            //let type = OrderTypes[0].value;
            let type = '';
            if (cart && cart.orderType) {
                type = cart.orderType;
            }
            return type;
        } else {
            return '';
        }
   
    }

    //useEffect(() => {
    //    if (OrderTypes && OrderTypes.length > 1) {
    //        setSelectedOrderType(GetCartType());
    //        //GetSKUDetail();
    //    }
    //}, [OrderTypes]);

    useEffect(() => {
        const processCart = async () => {
            CheckSession();

            // if (cart && cart.callAPI === true) {
            //     setSelectedOrderType(cart.orderType);
            //     setCallAPI(true);
            //     return;
            // }

            /*const cart = GetShoppingCart();*/
            if (cart && cart.items) {
                /*setItemInfoLoad(true);*/
                const crrMap = new Map();
                let acctotal = 0, parttotal = 0, othertotal = 0;
                const skuqty = [];
                const updatedSkus = [];
                cart.items.forEach(element => {
                    if (element.item.qtyOrdered > 0) {
                        //const itmNum = element.item.distitemNbr.replaceAll('-', '')
                        if (element.item.new === true) {
                            updatedSkus.push({
                                sku: element.item.distitemNbr,
                                qty: element.item.qtyOrdered,
                                vin: element.item.vin
                            });
                        } else {
                            const id = getSelectedItemKey(element);
                            crrMap.set(id, element);
                            //acctotal += element.item.qty * element.item.dealerPrice;
                            const qty = element.item.qty + element.item.boCnt;
                            if (element.item.inventoryType === "A") {
                                parttotal += qty * element.item.dealerPrice;
                            } else if (element.item.inventoryType === "B") {
                                acctotal += qty * element.item.dealerPrice;
                            } else {
                                othertotal += qty * element.item.dealerPrice;
                            }
                            skuqty.push({
                                sku: element.item.distitemNbr,
                                qty: element.item.qtyOrdered,
                                vin: element.item.vin,
                                ...(isBulkImportItem(element)
                                    ? { rowKey: element.rowKey }
                                    : {})
                            });
                        }
                        //toggleMemo(itmNum);
                    }
                });

                let oName = cart ? cart.orderName : '';
                oName = oName ? oName : "";
                if (oName.trim() === '') {
                    oName = generateSixDigitNumber();
                }
                cart.orderName = oName;
                setSelectedItems(crrMap);
                setAccSubtotal(acctotal);
                setParSubtotal(parttotal);
                setOtherSubtotal(othertotal);
                setItemsNumberQtyArr(skuqty);
                setAlerts(cart.alerts);
                setOrderName(cart.orderName);
                if (!cart.shipToDealerID) {
                    const user = GetCoockie();
                    cart.shipToDealerID = user.dealerID;
                }
                setShipToDealerID(cart.shipToDealerID);
                setSelectedOrderType(cart.orderType);
                // setShoppingCart(cart);;
                // if (SelectedOrderType && SelectedOrderType !== '') {
                //     GetSKUDetail();
                // }
                if (updatedSkus.length > 0) {
                    setUpdateMode(true);
                    setChangedSKU(updatedSkus);
                }
                if (skuqty && skuqty.length > 0) {
                    SaveOrderIntoTempTable(skuqty, 2);
                }
            }
            /*setItemInfoLoad(false);*/
            setFromNonOrderFrom(true);
        }

        processCart();

    }, [shoppingCart])

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'orderName') {
            setOrderName(value);
        } else if (name === 'kCode') {
            setKCode(value);
        } else if (name === 'partNum') {
            setPartNum(value);
        } else if (name === 'partQty') {
            if (value === '') {
                setPartQty('');
            } else if (/^[1-9]\d*$/.test(value)) {
                setPartQty(Number(value));
            }
        }
        // else if (name === 'partMemo') {
        //     setPartMemo(value);
        // }
        else if (name === 'exchangeOrder') {
            setExchangeOrder(event.target.checked);
        } else if (name === 'thirdParty') {
            setThirdParty(value);
        } else if (name === 'dropShipAddress') {
            setDropShipAddress(value)
        } else if (name === 'dropShipAddress2') {
            setDropShipAddress2(value)
        } else if (name === 'dripShipName') {
            setDropShipCrrName(value)
        } else if (name === 'dropShipCity') {
            setDropShipCity(value)
        } else if (name === 'dropShipState') {
            setDropShipState(value)
        } else if (name === 'dropShipZipCode') {
            setDropShipZipCode(value)
        } else if (name === 'manualDropShip') {
            setManualDropShip(!manualDropShip);
        }
    };

    const selectedShipItem = ShipCodes?.find(
        (item) =>
            item.shipCode === ShipMethod
    );

    const handleSelectItem = (e) => {
        const sku = e.target.id.substring(5);
        const set = new Set(checkedItems);
        if (e.target.checked) {
            set.add(sku);
        } else {
            set.delete(sku);
        }
        setCheckedItems(set);
    }

    const fetchStates = async () => {
        const response = await fetch("checkouth/GetStates");
        const states = await response.json();
        setStateOptions(states);
    }

    useEffect(() => {
        const skuArray = Array.from(selectedItems.values());

        if (checkedItems.size === skuArray.length && checkedItems.size > 0) {
            setSelectAll(true);
        } else {
            setSelectAll(false);
        }
    }, [checkedItems])

    useEffect(() => {
        if (OrderName && cart && cart.orderName && OrderName !== cart.orderName) {
            if (cart) {
                const map = new Map(selectedItems);
                const newCartItems = Array.from(map.values());
                const newCart = {
                    alerts: cart.alerts,
                    items: newCartItems,
                    orderName: OrderName,
                    orderType: cart.orderType,
                    shipToDealerID: cart.shipToDealerID,
                    kCode: cart.kCode ?? '',
                    fromVIPortal: (cart && cart.fromVIPortal) ?? false
                }
                UpdateShoppingCart(newCart, setShoppingCart);
            }
        }
    }, [OrderName])

    const CheckOrderName = async (currentStep) => {
        if (OrderName && OrderName !== '') {
            CheckSession();
            const user = GetCoockie();
            const data = {
                label: OrderName,
                value: user.dealerID,
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };

            const res = await fetch('kdealer/CheckOrderName', requestOptions);

            if (res.status === 200) {
                const js = await res.text();
                if (js === "0") {
                    //duplicate order name, show pop-up
                    setPopUpMsg('No duplicate order names allowed, please enter a new order name.');
                    handlePopUpModalShow();
                    document.getElementById('orderName').classList.add('is-invalid');
                } else {
                    if (currentStep === 1) {
                        setOrderStep(2);
                        setUpdateMode(true);
                        setSelectedOrderType(localSelectedOrderType);
                    } else {
                        handleStep3Continue();
                    }
                    document.getElementById('orderName').classList.remove('is-invalid');
                }
            }
        } else {
            if (currentStep === 1) {
                setOrderStep(2);
                setUpdateMode(true);
                setSelectedOrderType(localSelectedOrderType);
            } else {
                handleStep3Continue();
            }
            document.getElementById('orderName').classList.remove('is-invalid');
        }
    }

    const selectAllItems = () => {
        const skuArray = Array.from(selectedItems.values());
        const set = new Set();
        if (selectMode) {
            for (let i = 0; i < skuArray.length; i++) {
                const key = getSelectedItemKey(skuArray[i]);
                set.add(key);
            }
        }
        setCheckedItems(set);
        setSelectMode(prev => !prev);
    }

    const handleSelectAll = () => {
        const skuArray = Array.from(selectedItems.values());
        const set = new Set();
        for (let i = 0; i < skuArray.length; i++) {
            const key = getSelectedItemKey(skuArray[i]);
            set.add(key);
        }
        setCheckedItems(set);
        setSelectAll(true);

        if (selectAll) {
            setSelectAll(false);
            setCheckedItems(new Set());
        }
    }

    const changeDealerID = (id) => {
        setDealerIdInput(id.label);

        const dealerAddress = allDealerAddresses.find(d => d.dealerID === id.value);
        setDealerChanged(dealerAddress || DefaultShipTo);
    }
    
    //const CheckDealerID = async (id) => {
    //    try {
    //        const response = await fetch("kdealer/GetDefaultShipTo/" + id);
    //        if (response.status !== 200) {
    //            return;
    //        }
    //        const add = await response.json();
    //        if (add && add.address) {
    //            setDealerChanged(add);
    //        }
    //    } catch (e) {
    //        console.log(e);
    //        return;
    //    }
    //}

    const LoadShipTo = async (id, isDefault) => {
        try {
            const response = await fetch("kdealer/GetDefaultShipTo/" + id);
            if (response.status !== 200) {
                return;
            }
            const add = await response.json();
            if (add && add.address) {
                if (isDefault) {
                    setDefaultShipTo(add);
                }
                setShipTo(add);
                setShipToDealerID(id);
            }
        } catch (e) {
            console.log(e);
            return;
        }
    }

    useEffect(() => {
        if (!OrderTypes) {
            LoadOrderType();
        }
    }, [OrderTypes])

    useEffect(() => {
        if (!ShipTo) {
            CheckSession();
            const user = GetCoockie();
            LoadShipTo(user.dealerID, true);
        }
    }, [ShipTo])

    useEffect(() => {
        setTotal(AccSubtotal + ParSubtotal + OtherSubtotal + EstFreight + EstHandling + EstSpecialFee);
    }, [AccSubtotal, ParSubtotal, OtherSubtotal, EstFreight, EstHandling, EstSpecialFee])

    const handleMemoChange = (e) => {
        if (selectedItems) {
            const vl = e.target.value.toUpperCase();
            const memoID = e.target.id.replace('memo-', '').replace('compact-', '');
            const id = memoID.startsWith('bulk_') ? memoID : memoID.toUpperCase();
            const item = selectedItems.get(id);

            if (item && item.item && item.item.vin !== vl) {
                item.item.vin = vl;
                const map = new Map(selectedItems);
                map.set(id, item);
                setSelectedItems(map);
                setUpdateMode(false);
                if (cart) {
                    const newCartItems = Array.from(map.values());
                    const newCart = {
                        alerts: cart.alerts,
                        items: newCartItems,
                        orderName: cart.orderName,
                        orderType: cart.orderType,
                        shipToDealerID: cart.shipToDealerID,
                        kCode: cart.kCode ?? '',
                        fromVIPortal: (cart && cart.fromVIPortal) ?? false
                    }
                    UpdateShoppingCart(newCart, setShoppingCart);
                }
            }
        }
    };

    // const handleAddToCart = async () => {
    //     try {
    //         console.log('add item')
    //         setItemsLoad(true);
    //         const partNumFormat = partNum.replace(/\s/g, "");
    //         if (!partNum) {
    //             setItemsLoad(false);
    //             setPopUpMsg('Please enter a part number to add to your cart.');
    //             handlePopUpModalShow();
    //             return;
    //         }
    //         let qty = parseInt(partQty);
    //         if (isNaN(qty) || qty <= 0) {
    //             //setItemsLoad(false);
    //             //return;
    //             qty = 1;
    //         }
    //         const cleanID = partNum.replaceAll('-', '') + (partMemo === '' ? '' : ('|' + partMemo));
    //         if (localQty[cleanID] && localQty[cleanID] !== qty) {
    //             qty += localQty[cleanID];
    //         }
    //         const skuqty = [];
    //         skuqty.push({
    //             sku: partNumFormat,
    //             qty: qty,
    //             vin: partMemo
    //         });
    //         if (skuqty.length === 0) {
    //             setItemsLoad(false);
    //             return;
    //         }
    //         setAddItem(true);
    //         setUpdateMode(true);
    //         setChangedSKU(skuqty);
    //         //await GetSKUDetailAddSingleItem(skuqty);
    //     } catch (e) {
    //         console.log(e);
    //         setItemsLoad(false);
    //         setPopUpMsg('There was an issue connecting to the Kawasaki server. Please try again later');
    //         handlePopUpModalShow();
    //     } finally {
    //         setPartNum('');
    //         setPartQty('');
    //         setPartMemo('');
    //     }
    // }

    const debounceRef = useRef({});

    // const updateQuantity = (id, vl, update) => {
    //     setItemInfoLoad(true);

    //     const item = selectedItems.get(id);
    //     if (!item || item.item.qtyOrdered === vl) {
    //         setItemInfoLoad(false);
    //         setPopUpMsg('There was an error connecting to the Kawasaki server. Please try again later');
    //         return;
    //     }

    //     const sku = item.item.distitemNbr.replaceAll('-', '');
    //     const vin = item.item.vin || '';
    //     const updatedSku = [{
    //         sku: sku,
    //         qty: vl,
    //         vin: vin,
    //         ...(isBulkImportItem(item)
    //             ? { rowKey: item.rowKey }
    //             : {})
    //     }];

    //     setLocalQty(prev => ({
    //         ...prev,
    //         [id]: vl,
    //     }));

    //     if (ItemsNumberQtyArr && ItemsNumberQtyArr.length > 0) {
    //         const skuqty = ItemsNumberQtyArr.map(element => {
    //             const elementKey = getRequestItemKey(element);
    //             const matchesItem = isBulkImportItem(item)
    //                 ? elementKey === id
    //                 : element.sku.replaceAll('-', '') === sku;

    //             return {
    //                 sku: element.sku,
    //                 qty: matchesItem ? vl : element.qty,
    //                 vin: element.vin,
    //                 ...(element.rowKey
    //                     ? { rowKey: element.rowKey }
    //                     : {})
    //             };
    //         });

    //         setItemsNumberQtyArr(skuqty);
    //         setUpdateMode(update);
    //         setChangedSKU(updatedSku);
    //     }
    // }

    const handleStep3Continue = () => {
        updateOrderContent();
        setOrderStep(3);
        setSubmitErrorMsg('');
        $('#SelectOrderType').removeClass('is-invalid');
    }

    const updateOrderContent = () => {
        if (userInfo?.loginType !== 5) {
            if (Object.keys(pendingQtyChanges).length === 0 && localSelectedOrderType === SelectedOrderType) {
                return;
            }
        } else {
            if (Object.keys(pendingQtyChanges).length === 0) {
                return;
            }
        }

        setItemInfoLoad(true);

        const updatedSkus = [];

        if (pendingQtyChanges && Object.keys(pendingQtyChanges).length > 0) {
            Object.entries(pendingQtyChanges).forEach(([id, qty]) => {
                const item = selectedItems.get(id);

                if (!item) {
                    return;
                }

                const sku = item.item.distitemNbr.replaceAll('-', '').toUpperCase();

                updatedSkus.push({
                    sku,
                    qty,
                    vin: item.item.vin || '',
                    ...(isBulkImportItem(item)
                        ? { rowKey: item.rowKey }
                        : {})
                });
            });
        } else {
            selectedItems.forEach((value, key) => {
                updatedSkus.push({
                    sku: value.item.distitemNbr,
                    qty: value.item.qtyOrdered,
                    vin: value.item.vin,
                    ...(isBulkImportItem(value)
                        ? { rowKey: key }
                        : {})
                });
            });
        }

        setChangedSKU(updatedSkus);
        if (userInfo?.loginType !== 5) {
            setSelectedOrderType(localSelectedOrderType);
        }
        setUpdateMode(true);

        setPendingQtyChanges({});
        GetSKUDetail();
        //setCallAPI(true);
    }

    const handleOrderQtyChange = (e) => {
        const id = e.target.id.replace('qty-', '').toUpperCase();
        const input = e.target.value;

        setLocalQty(prev => ({
            ...prev,
            [id]: input,
        }));

        if (input !== '' && parseInt(input) >= 0) {
            const raw = ValidateQty(input);
            if (raw.length > 0) {
                const vl = parseInt(raw);

                if (vl > 0) {
                    setLastValidQty(prev => ({
                        ...prev,
                        [id]: vl,
                    }));

                    setPendingQtyChanges(prev => ({
                        ...prev,
                        [id]: vl,
                    }));
                }
            }
        }
    }

    const handleOrderQtyBlur = (e, index) => {
        const id = e.target.id.replace('qty-', '').toUpperCase();
        const input = e.target.value.trim();
        const values = Array.from(selectedItems.values());

        if (parseInt(input) !== parseInt(values[index].item.qtyOrdered)) {

            if (input === '') {
                setLocalQty((prev) => ({
                    ...prev,
                    [id]: lastValidQty[id],
                }));

                handleQtyModalShow();
                return;
            }

            const qty = parseInt(input);

            if (qty < 0) {
                setLocalQty(prev => ({
                    ...prev,
                    [id]: lastValidQty[id],
                }));
                handleQtyModalShow();
                return;
            }

            if (qty === 0) {
                const set = new Set(checkedItems);
                set.add(id);
                setCheckedItems(set);

                handleDeleteModalOpen();
                return;
            }

            //if (qty !== parseInt(values[index].item.qtyOrdered)) {
            //    const raw = ValidateQty(input);
            //    const vl = parseInt(raw);

            //    setLocalQty(prev => ({
            //        ...prev,
            //        [id]: vl,
            //    }));

            //    updateQuantity(id, vl, true);
            //}
        }
    }

    const LoadShipMethods = async () => {
        try {
            CheckSession();
            const session = GetCoockie();

            if (!selectedItems || selectedItems.size === 0 || !ShipToDealerID || !SelectedOrderType) {
                return;
            }
            /*setShipLoad(true);*/
            let arr = [];
            Array.from(selectedItems.values()).forEach(element => {
                arr.push(element.item);
            });
            const data = {
                orderType: SelectedOrderType,
                shipToDealerID: ShipToDealerID,
                dealerId: session.dealerID,
                items: arr,
                subtotal: AccSubtotal + ParSubtotal + OtherSubtotal,
                //over1000d: AccSubtotal > 1000
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };

            const res = await fetch('kdealer/GetFreightInfo', requestOptions);

            if (res.status === 200) {
                const js = await res.json();
                setShipCodes(js);
                //setShipMethod();
            }
            if (session.loginType === 5 || session.dealerID === '0336') {
                LoadShipMethodsInternaltion(session.dealerID);
            }
            /*handleClosePop();*/
            /*setShipLoad(false);*/
            return true;
        } catch (e) {
            console.log(e);
            /*handleClosePop();*/
            /*setShipLoad(false);*/
            return false;
        }
    }

    useEffect(() => {
        if (ShipCodes && ShipCodes.length > 0) {
            ChangeShipMethod(ShipCodes[0].shipCode);
        }
       
    }, [ShipCodes])

    const SendSKUQtyToItemInquiry = async (skuqty) => {
        if (!skuqty) {
            return;
        }
        handleImportModalClose();
        //setValuesForItemInquiry(null);
        setBulkLoad(skuqty);
        setFromImport(true);
        setShowItemModal(true);
    }

    const LoadShipMethodsInternaltion = async (dealerID) => {
        try {

            if (!selectedItems || selectedItems.size === 0 || !dealerID || !SelectedOrderType) {
                return;
            }
            const res = await fetch('kdealer/GetInternationlForwardInfo/' + dealerID);

            if (res.status === 200) {
                const js = await res.json();
                const map = new Map();
                const submap = new Map();
                js.forEach(element => {
                    map.set(element.type, element.addresses);
                    element.addresses.forEach(d => {
                        submap.set(d.carrCode, d);
                    });
                });
                setForwarderAddresses(map);
                setAllForwarderAddMap(submap);
                console.log(map);
                return true;
            }
        } catch (e) {
            console.log(e);
            return false;
        }
        return false;
    }

    useEffect(() => {
        if (SelectedOrderType === '4' && (manualDropShip || DropShipAdd)) {
            setDropShipValidator(false);
        }
    }, [manualDropShip, DropShipAdd])

    const handleClickOrderID = () => {
        if (!OrderID || OrderID === '') {
            return;
        }
        navigate('/OrderHistory', { state: { id: OrderID } });
    }

    const SubmitOrder = async (checkKcode) => {
        try {
            handlePop();
            CheckSession();
            let validated = true;

            //const char1 = ShipMethod.substring(0, 1);
            //const char2 = parseInt(ShipMethod.substring(1, 2))
            $('#SelectForwarderAdd').removeClass('is-invalid');
            $('#SelectShipMethod').removeClass('is-invalid');
            $('#SelectOrderType').removeClass('is-invalid');
            if (ShipToDealerID === "0336") {
                $('#thirdParty').removeClass('is-invalid');
            }
            if (SelectedOrderType === '') {
                $('#SelectOrderType').addClass('is-invalid');
                validated = false;
            }
            if (SelectedOrderType === '4') {
                $('#dAddress1').removeClass('is-invalid');
                $('#dName').removeClass('is-invalid');
                $('#dCity').removeClass('is-invalid');
                $('#dState').removeClass('is-invalid');
                $('#dZip').removeClass('is-invalid');
                setDropShipValidator(false);
                if (manualDropShip === false && DropShipAdd === null) {
                    //check if manually input dropship address
                    setDropShipValidator(true);
                    validated = false;
                } else if (manualDropShip) {
                    if (dropShipAddress.trim() === '') {
                        $('#dAddress1').addClass('is-invalid');
                        validated = false;
                    }
                    if (dropShipCrrName.trim() === '') {
                        $('#dName').addClass('is-invalid');
                        validated = false;
                    }
                    if (dropShipCity.trim() === '') {
                        $('#dCity').addClass('is-invalid');
                        validated = false;
                    }
                    if (dropShipState.trim() === '') {
                        $('#dState').addClass('is-invalid');
                        validated = false;
                    }
                    if (dropShipZipCode.trim() === '') {
                        $('#dZip').addClass('is-invalid');
                        validated = false;
                    }
                }
                if (manualDropShip === true) {
                    setDropShipAdd('');
                }
                if (ShipMethod.startsWith('3')) {
                    //if (!DropShipAdd || DropShipAdd.indexOf("Select") > -1) {
                    //    $('#SelectDropShipAdd').addClass('is-invalid');
                    //    validated = false;
                    //}
                    if (!thirdParty) {
                        $('#thirdParty').addClass('is-invalid');
                        validated = false;
                    }

                }
            }
            if (!ShipMethod) {
                $('#SelectShipMethod').addClass('is-invalid');
                validated = false;
            }
            else if ((ShipMethod === "I4" || ShipMethod === "I5" || ShipMethod === "I6") && !DropShipAdd) {
                $('#SelectDropShipAdd').addClass('is-invalid');
                validated = false;
            }
            else if ((ShipMethod === "I7" || ShipMethod === "I8") && (!ForwarderAdd || !DropShipAdd)) {
                if (!ForwarderAdd || ForwarderAdd.indexOf("Select") > -1) {
                    $('#SelectForwarderAdd').addClass('is-invalid');
                    validated = false;
                }
                if (!DropShipAdd) {
                    $('#SelectDropShipAdd').addClass('is-invalid');
                    validated = false;
                }
            }

            if (selectedItems.size === 0) {
                validated = false;
            }

            if (!validated) {
                return;
            }
            let items = [];
            for (const value of selectedItems.values()) {
                let val = value.item;
                //const itmNum = value.item.distitemNbr.replaceAll('-', '');
                //val["memo"] = SKUMemo.has(itmNum) ? SKUMemo.get(itmNum) : '';
                items.push(val);
            }

            const session = GetCoockie();
            //const hasKCode = Total > 1000 && SelectedOrderType === "3" && kCode && kCode !== "";
            const hasKCode = SelectedOrderType === "3" && kCode && kCode !== "";
            if (IsTestDealer(session.dealerID)) {
                return;
            }
            const data = {
                /* body: {*/
                orderName: OrderName ? OrderName : '',
                orderType: SelectedOrderType,
                itemExchange: exchangeOrder,
                shipToDealer: ShipToDealerID,
                shipToMethod: ShipMethod,
                partsSubtotal: ParSubtotal,
                accSubtotal: AccSubtotal,
                otherSubtotal: OtherSubtotal,
                estFreight: EstFreight,
                estHandling: EstHandling,
                estSpecialFee: EstSpecialFee,
                dealerId: session.dealerID,
                forwarderAddressCode: ForwarderAdd ? ForwarderAdd : '',
                dropshipAddressCode: DropShipAdd ? DropShipAdd : '',
                items: items,
                kCode: hasKCode ? kCode.trim() : '',
                userKey: session.userKey,
                checkKCodeOnly: checkKcode,
                accountNumber: thirdParty,
                dropshipAddressName: dropShipCrrName,
                dropshipAdress1: dropShipAddress,
                dropshipAddress2: dropShipAddress2,
                dropshipCity: dropShipCity,
                dropshipZip: dropShipZipCode,
                dropshipStateKey: dropShipState,
                buyerCookie: session.buyerCookie
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            cart.kCode = hasKCode ? kCode.trim() : '';
            UpdateShoppingCart(cart, setShoppingCart);

            const resOrder = await fetch('kdealer/SubmitNewOrder', requestOptions);
            let KMCOrderID = '';
            let SESOrderID = '';
            let orderName = '';
            if (resOrder.status === 200) {
                if (checkKcode === true) {
                    setAppliedKCode(kCode);
                    setSubmitErrorMsg('');
                } else {
                    setSubmit(true);
                    const js = await resOrder.json();
                    SESOrderID = js.orderIDSES;
                    orderName = js.orderName;
                    setOrderID(js.orderIDKMC);
                    setCreditHold(js.creditHold)
                    /*localStorage.clear();*/
                    //UpdateShoppingCart(null);
                    //setShoppingCart(null);
                    
                    if (js.orderIDKMC !== '') {
                        //submitted to KMC
                        clearCart();
                        KMCOrderID = js.orderIDKMC;
                    } else {
                        //Failed to submit to KMC
                        //show message: allow XX time for order to reflect in order status
                        setWaitMsg(true);
                    }
                    clearCart();
                    document.getElementById('top').scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
                if (session.buyerCookie && session.buyerCookie !== '') {
                    const userObj = {
                        'firstName': session.firstName,
                        'lastName': session.lastName,
                        'email': session.email,
                        'dealerKey': session.dealerKey,
                        'userKey': session.userKey,
                        'dealerName': session.dealerName,
                        'dealerID': session.dealerID,
                        'loginType': session.loginType,
                        'region': session.address,
                        'isAdmin': session.isAdmin,
                        'loading': 0,
                        'buyerCookie': ''
                    };

                    let domain = GetDomain();
                    console.log('domain: ' + domain);

                    if (domain === '') {
                        Cookies.set('user', JSON.stringify(userObj), { expires: days });
                    } else {
                        Cookies.set('user', JSON.stringify(userObj), { expires: days, domain: domain, secure: true });
                    }
                }
                //call order status
                CheckSession();
                const user = GetCoockie();
                const data = {
                    orderIDSES: SESOrderID,
                    orderIDKMC: KMCOrderID,
                    creditHold: false,
                    orderName: orderName,
                    dealerID: user.dealerID,
                    userKey: user.userKey
                }
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-type': 'application/json'
                    },
                    body: JSON.stringify(data)
                };
                fetch("kdealer/GetOrderStatus", requestOptions);
            } else if (resOrder.status === 401) {
                const js = await resOrder.json();
                console.log(js)
                //let msg = js.errMsg;
                //if (js.items.length > 0) {
                //    msg += "\nOne or more items in your shopping cart are not eligible for the selected K-code:\n";
                //}
                //js.items.forEach(element => {
                //    msg += element.value;
                //});
                setSubmitErrorMsg(js.errMsg);
                if (js.items.length > 0) {
                    setInvalidKCodeSKUList(js.items);
                    //setPopUpMsg(js.errMsg);
                    //handlePopUpModalShow();
                    console.log(js.items);
                }
                setAppliedKCode('');
                setPopUpMsg(js.errMsg);
                handlePopUpModalShow();
                //setKCode('');
            } else {
                if (!checkKcode) {
                    setPopUpMsg('There was an error while submitting your order. Please try again later.');
                    handlePopUpModalShow();
                } else {
                    setPopUpMsg('There was an error while submitting the K-Code. Please try again later.');
                    handlePopUpModalShow();
                }
            }
        } catch (e) {
            console.log(e);
            if (!checkKcode) {
                setPopUpMsg('There was an error while submitting your order. Please try again later.');
                handlePopUpModalShow();
            } else {
                setPopUpMsg('There was an error while submitting the K-Code. Please try again later.');
                handlePopUpModalShow();
            }
            return;
        } finally {
            handleClosePop();
        }
    }

    const handleKCodeSave = () => {
        if (kCodeRadio === "1") {
            removeInvalidItems(true);
            handlePopUpModalClose();
        } else if (kCodeRadio === "2") {
            removeInvalidItems(false);
            handlePopUpModalClose();
        } else if (kCodeRadio === "3") {
            setKCode('');
            if (cart) {
                cart.kCode = '';
                UpdateShoppingCart(cart, setShoppingCart);
            }
            handlePopUpModalClose();
        }
        setSubmitErrorMsg('');
    }

    const removeInvalidItems = async (save) => {
        try {
            const map = new Map(selectedItems);
            const skuqty = [];

            invalidKCodeSKUList.forEach((sku) => {
                const formatedSKU = sku.value.replaceAll(' ', '').replaceAll('-', '').toUpperCase();
                if (map.has(formatedSKU)) {
                    if (save === true) {
                        const skuInfo = map.get(formatedSKU);
                        skuqty.push({
                            sku: skuInfo.item.distitemNbr,
                            qty: skuInfo.item.qty,
                            vin: skuInfo.item.vin
                        });
                        setOrderSaved(true);
                    }
                    map.delete(formatedSKU);
                }
            });
            if (save === true && skuqty.length > 0) {
                SaveOrderIntoTempTable(skuqty, 1);
            }
            setSelectedItems(map);
            const arrSubs = [];
            let errorSet = new Set();
            let alertFactor = 0, boCount = 0;
            let LTL = false;
            let pk = false;
            const skuObjs = [];
            map.forEach((value, key) => {
                const cleanItemNum = value.item.distitemNbr.replaceAll('-', '').toUpperCase();
                if (value.item.errorMsg !== "") {
                    if (value.item.errorMsg.toLowerCase().indexOf("invalid") > -1) {
                        errorSet.add("At least one Item Number is invalid.");
                    } else {
                        errorSet.add(value.item.errorMsg);
                    }

                } else {
                    skuObjs.push(value);
                    if (cleanItemNum !== "") {
                        if (value.item.qtyOrdered > 0) {
                            if (value.item.substitutedSKU !== "") {
                                arrSubs.push(`${value.item.substitutedSKU} is substituted by ${value.item.distitemNbr}`);
                            }
                            if (value.item.factorAlert) {
                                alertFactor++;
                            }
                            if (value.item.boCnt > 0) {
                                boCount++;
                            }
                            if (value.item.ltl === true) {
                                LTL = true;
                            }
                            if (value.item.pk === true) {
                                pk = true;
                            }
                        }

                    }
                }
            });

            const alerts = [
                alertFactor > 0 && { type: 'packQuantity' },
                boCount > 0 && { type: 'backorder' },
                LTL && { type: 'ltlShipping' },
                pk && { type: 'packageBuilt' },
                arrSubs.length > 0 && { type: 'substitutions' }
            ].filter(Boolean);

            handleSelectedItems({ items: skuObjs, alerts: alerts }, true);
        } catch (e) {
            console.log(e);
        }
    }

    const resumeSavedOrder = async () => {
        if (separatedOrder) {
            try {
                CheckSession();
                handlePop();
                const user = GetCoockie();
                const data = {
                    label: user.dealerID,
                    value: separatedOrder.toString()
                }
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-type': 'application/json'
                    },
                    body: JSON.stringify(data)
                };
                const response = await fetch("kdealer/GetSavedOrder", requestOptions);
                if (response.status !== 200) {
                    //error message
                    return;
                }
                const items = await response.json();
                const skuqty = [];
                items.items.forEach(element => {
                    skuqty.push({
                        sku: element.sku,
                        qty: element.qty,
                        vin: element.vin
                    });
                });
                const res = await GetSKUDetailGlb(skuqty, items.orderType, items.orderName, items.shipTo.dealerID);
                if (res && res.cart) {
                    UpdateShoppingCart(res.cart, setShoppingCart);
                    window.location.reload();
                }
                else if (res && res.error) {
                    //error message
                }

            } catch (e) {
                console.log(e);
            }
            finally {
                handleClosePop();
            }
        }
    }

    // useEffect(() => {
    //     if (selectedItems.size > 0 && kCode) {
    //         handleAddKCode();
    //     }
    // }, [selectedItems]);

    const getStatusIcon = (code) => {
        const color = code.charAt(0);
        const number = code.slice(1);

        switch (color) {
            case "G":
                return (
                    <div className="icons-row">
                        <div className="status-icon green-icon"></div>
                    </div>
                );
            case "Y":
                return (
                    <div className="icons-row">
                        <div className="status-icon yellow-icon"></div>
                    </div>
                );
            default:
                return (
                    <div className="icons-row">
                        <div className="status-icon red-icon"></div>
                    </div>
                );
        }
    };

    const fullViewIcon = <span className="svg-holder">
        <img src="../../../Images/icon-full-view.svg" alt="Full View" /> {t("order.fullView")}
    </span>

    const compactViewIcon = <span className="svg-holder">
        <img src="../../../Images/icon-compact-view.svg" alt="Full View" /> {t("order.compactView")}
    </span>

    const handleAddKCode = () => {
        //add K-Code
        SubmitOrder(true);
    }

    const handlePrint = useReactToPrint({
        contentRef,
        onBeforeGetContent: () => {
            return new Promise((resolve, reject) => {
                if (!contentRef.current) {
                    reject(new Error('There is nothing to print'));
                } else {
                    promiseResolveRef.current = resolve;
                    setIsPrinting(true);
                }
            });
        },
        onAfterPrint: () => {
            promiseResolveRef.current = null;
            setIsPrinting(false);
        },
        onPrintError: (errorLocation, error) => {
            console.error('Print error at:', errorLocation, error);
            setTimeout(() => {
            }, 0);
        }
    });

    const tryPrint = () => {
        if (selectedItems.size === 0) {
            setPopUpMsg(
                'There was an error while attempting to print your cart. Please ensure you have at least one item in your cart before printing.'
            );
            handlePopUpModalShow();
        } else {
            /*setViewMode(2);*/
            handlePrint();
        }
    }

    const selectedOrderTypeLabel = OrderTypes?.find(
        (t) => String(t.value) === String(SelectedOrderType)
    )?.label;

    const shipMethodLabel = ShipCodes?.find(
        (t) => String(t.shipCode) === String(ShipMethod)
    )?.shipMethodName;

    // useEffect(() => {
    //     const total = Array.from(selectedItems.values()).reduce((sum, d) => {
    //         const price = d.item.dealerPrice || 0;
    //         const qty = d.item.qty || 0;
    //         const boCnt = d.item.boCnt || 0;
    //         return sum + price * (qty + boCnt);
    //     }, 0);
    //     setRunningTotal(total);
    // }, [selectedItems])

    return (
        <>
            <Container className="checkout-container main-container">
                <style type="text/css" media="print">
                    {"\
                            @page { size: portrait; margin: 0.5in; }\
                        "}
                </style>

                <div style={{ display: 'none' }}>
                    <PrintableOrder
                        ref={contentRef}
                        selectedItems={selectedItems}
                        total={runningTotal}
                        orderName={OrderName}
                        orderType={selectedOrderTypeLabel}
                        kCode={kCode}
                        shipTo={ShipTo}
                        shipMethod={shipMethodLabel}
                        partsTotal={ParSubtotal}
                        accTotal={AccSubtotal}
                        otherTotal={OtherSubtotal}
                        estFreight={SpecialDealerFeeText ? SpecialDealerFeeText : EstFreight}
                        estHandling={EstHandling}
                        estSpecialFee={EstSpecialFee}
                        grandTotal={Total}
                        showPrice={orderStep === 3 ? true : false}
                        orderID={OrderID}
                    />
                </div>

                <Row className="help-title-row checkout-title-row">
                    <Col className="help-center-title checkout-title" id="top">
                        <h1 className="heading help-heading">{t('Order.ORDER FORM')}</h1>
                    </Col>
                    <Col className="checkout-title-under">
                        <Row>
                            <Col>
                                <p className="bold underline no-click text-right">
                                    <span className="svg-holder small-svg fit-content-width clickable">
                                        <a href="../../../downloads/Kawasaki_Ordering_Guide.pdf" target="_blank" rel="noreferrer" className="black-text">
                                            <img src="../../../Images/icon-open-book.svg" alt="Print" style={{ height: '20px', verticalAlign: 'middle' }} />
                                            {t('Order.Order Quick Reference')}
                                        </a>
                                    </span>
                                </p>
                            </Col>

                            <Col className="fit-content-width-col">
                                <p className="bold underline no-click text-right">
                                    <span className="svg-holder small-svg fit-content-width clickable" onClick={() => SaveOrder()}>
                                        <img src="../../../Images/icon-bookmark.svg" alt="Print" style={{ height: '20px', verticalAlign: 'middle' }} />
                                        {t('order.save Order')}
                                    </span>
                                </p>
                            </Col>

                            <Col className="fit-content-width-col">
                                <p className="bold underline no-click text-right" id="btnPrint">
                                    <span className="svg-holder small-svg fit-content-width clickable" onClick={() => tryPrint()}>
                                        <img src="../../../Images/printer-icon.svg" alt="Print" style={{ height: '30px', marginTop: '-8px', marginRight: '2px' }} />
                                        {t('Order.Print Cart')}
                                    </span>
                                </p>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row className="dealer-section min-height-spacing">
                    <Col md={12}>

                        {!submit ?
                            <>
                                <Card className="mb-3">
                                    <Card.Body>
                                        <Row>
                                            <Col sm={12}>
                                                <Card.Title className="vertical-line heading card-main-title active-heading" role="heading">
                                                    <span className="smaller-text heading">{t("order.step1")} </span> {t("order.orderDetails")}
                                                </Card.Title>
                                            </Col>
                                        </Row>

                                        <Row className="mt-2 gy-3">
                                            <Col lg={10} md={12}>
                                                <Row className="gy-3">
                                                    {userInfo?.loginType !== 5 &&
                                                        <Col md={4} lg={4}>
                                                            <FloatingLabel label="Order Type">
                                                                <Form.Select id="SelectOrderType" aria-label="Select Order Type" className="tall-select" onChange={ChangeOrderType} value={localSelectedOrderType} disabled={orderStep === 3}>
                                                                    <option key={'orderTypeNull'} value={''}>{'Select'}</option>
                                                                    {OrderTypes && OrderTypes.map((d) =>
                                                                        <option key={d.value} value={d.value}>{d.label}</option>
                                                                    )}
                                                                </Form.Select>
                                                            </FloatingLabel>
                                                        </Col>
                                                    }

                                                    <Col md={4} lg={4}>
                                                        <FloatingLabel label={t("order.orderName")}>
                                                            <Form.Control id="orderName" type="text" placeholder="Order Name" value={OrderName} className={'form-control'} onChange={handleChange} name="orderName" maxLength={200} disabled={orderStep === 3} />
                                                        </FloatingLabel>
                                                    </Col>

                                                    {userInfo?.loginType !== 5 &&
                                                        <Col md={4} lg={4}>
                                                            <div className={exchangeOrder ? "green-border h-100 pl-2 align-content-center" : "gray-border gray-bg h-100 pl-2 align-content-center"}>
                                                                <Form.Check
                                                                    type="switch"
                                                                    name="exchangeOrder"
                                                                    aria-label='Item Exchange'
                                                                    label="Item Exchange"
                                                                    onChange={handleChange}
                                                                    checked={exchangeOrder}
                                                                />
                                                            </div>
                                                        </Col>
                                                    }
                                                </Row>
                                            </Col>

                                            <Col lg={2} md={12} className="text-right">
                                                {orderStep === 1 ?
                                                    <Button variant="primary" onClick={() => handleGoToStep2()} className="mt-1">
                                                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                        </svg>
                                                        CONTINUE
                                                    </Button>
                                                : orderStep === 3 &&
                                                    <Button variant="secondary" onClick={() => setOrderStep(2)} className="mt-1">
                                                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                        </svg>
                                                        EDIT
                                                    </Button>
                                                }
                                            </Col>
                                        </Row>

                                        {userInfo?.loginType !== 5 &&
                                            <Row className="mt-4">
                                                <Col sm={12}>
                                                    <p className="red mb-0">
                                                        *Note: All Stocking orders are subject to shipping from the <b>Ontario, CA warehouse</b>. If an order is urgent, please submit it
                                                        as a <b>Regular</b> or <b>Emergency</b> order.
                                                    </p>
                                                </Col>
                                            </Row>
                                        }
                                    </Card.Body>
                                </Card>

                                <Card className="m-t-sm mb-3">
                                    <Card.Body>
                                        {orderStep >= 2 ?
                                            <>
                                                <Row>
                                                    <Col sm={12} md={6}>
                                                        <Card.Title className="vertical-line heading card-main-title active-heading" role="heading">
                                                            <span className="smaller-text heading">{t("order.step2")} </span> {t("order.itemDetails")}
                                                        </Card.Title>
                                                    </Col>

                                                    <Col sm={12} md={6} className="text-right">
                                                        <div className="default-row">                                            
                                                            <Button variant="secondary" onClick={handleImportModalShow} className="mt-2" disabled={orderStep === 3}>
                                                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                                </svg>
                                                                {t('Order.IMPORT ITEMS')}
                                                            </Button>

                                                            <Button variant="secondary" onClick={handleItemModalShow} disabled={orderStep === 3} className="ml-4 mt-2">
                                                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                                </svg>
                                                                {'ADD MULTIPLE'}
                                                            </Button>

                                                            <Button variant="primary" onClick={() => setDropdownOpen(true)} className="ml-4 mt-2" disabled={orderStep === 3}>
                                                                + {t('Order.ADD ITEMS')}
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>

                                                {selectedItems.size > 0 ?
                                                    <>
                                                        <div className="sticky fixed-legend">
                                                            <Row className="mt-3">
                                                                {orderStep === 2 &&
                                                                    <Col sm={6} className="padding-left-extra-md">
                                                                        <DropdownButton
                                                                            variant="outline-dark"
                                                                            title={t("order.actions")}
                                                                            id="actions-dropdown"
                                                                            className="mt-2 mb-2 dropdown-actions d-block"
                                                                        >
                                                                            <Dropdown.Item onClick={handleDeleteModalOpen} ><span className="svg-holder"><img src="../../../Images/cancelled-inactive.svg" alt="Delete" /> {t("order.delete")}</span></Dropdown.Item>
                                                                        </DropdownButton>
                                                                    </Col>
                                                                }

                                                                <Col sm={orderStep === 2 ? 6 : 12} className="text-right">
                                                                    <DropdownButton
                                                                        variant="outline-dark"
                                                                        title={viewMode === 1 ? fullViewIcon : compactViewIcon}
                                                                        id="view-dropdown"
                                                                        className="dropdown-actions mt-2 mb-2"
                                                                    >
                                                                        <Dropdown.Item onClick={() => { setViewMode(1); SaveUserPreferedViewMode(1); }}>{fullViewIcon}</Dropdown.Item>
                                                                        <Dropdown.Item onClick={() => { setViewMode(2); SaveUserPreferedViewMode(2); }}>{compactViewIcon}</Dropdown.Item>
                                                                    </DropdownButton>
                                                                </Col>
                                                            </Row>

                                                            <Row className="table-legend mt-1 mb-2 gy-3">
                                                                {orderStep === 2 &&
                                                                    <Col lg={2} className="padding-left-extra-md align-content-center">
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            name="selectAll"
                                                                            aria-label='Select All'
                                                                            label={t("form.Select All")}
                                                                            checked={selectAll}
                                                                            onChange={handleSelectAll}
                                                                        />
                                                                    </Col>
                                                                }

                                                                <Col lg={orderStep === 2 ? 10 : 12} className="text-center align-content-end">
                                                                    <div className="table-legend-section">
                                                                        <span className="svg-holder"><img src="../../../Images/parts.svg" alt="" className="" /> {t('table.Parts')}</span>
                                                                        <span className="svg-holder"><img src="../../../Images/accessories.svg" alt="" className="" /> {t('table.Accessories')}</span>
                                                                        <span className="svg-holder"><img src="../../../Images/other.svg" alt="" className="" /> {t('table.Other')}</span>
                                                                    </div>

                                                                    <div className="table-legend-section">
                                                                        <span className="icons-row"><div className={`status-icon green-icon`}></div> {t("table.Available")}</span>
                                                                        <span className="icons-row"><div className={`status-icon yellow-icon`}></div> {t("table.Partial")}</span>
                                                                        <span className="icons-row"><div className={`status-icon red-icon`}></div> {t("table.Unavailable")}</span>
                                                                    </div>

                                                                    <div className="table-legend-section">
                                                                        <span className="svg-holder"><img className="asterisk-img" src={"../../../Images/asterisk.svg"} alt="asterisk" /> {t("table.Pkg Qty")}</span>
                                                                        <span className="svg-holder"><img src="../../../Images/substitute.svg" alt="" className="" /> {t("table.Substitute")}</span>
                                                                        <span className="svg-holder"><img className="" src={"../../../Images/LTL.svg"} alt="LTL" /> {t("table.LTL")}</span>
                                                                        <span className="svg-holder"><img src="../../../Images/backorder.svg" alt="" className="" /> {t("table.Backorder")}</span>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </div>

                                                        <div className="item-inquiry-list">
                                                            <div className="alerts-section" style={!hasAlert('packQuantity') && !hasAlert('ltlShipping') && !hasAlert('substitutions') && ((AccSubtotal + ParSubtotal + OtherSubtotal) < 1000 || isDealer === false) && !hasAlert('backorder') && !hasAlert('packageBuilt') ? { border: "none" } : {}} >
                                                                <Row>
                                                                    {hasAlert('packQuantity') &&
                                                                        <Col sm={12}>
                                                                            <div className="icons-row alert-noti asterisk-noti text-left">
                                                                                <span className="svg-holder small-svg">
                                                                                    <img className="asterisk-img" src={"../../../Images/asterisk.svg"} alt="asterisk"></img>
                                                                                </span>

                                                                                <p className="mb-0">There is at least one item with the order quantity increased to a factor of the package quantity.</p>
                                                                            </div>
                                                                        </Col>
                                                                    }
                                                                    {hasAlert('ltlShipping') &&
                                                                        <Col sm={12}>
                                                                            <div className="icons-row alert-noti ltl-noti text-left">
                                                                                <span className="svg-holder small-svg">
                                                                                    <img className="" src={"../../../Images/LTL.svg"} alt="LTL"></img>
                                                                                </span>

                                                                                <p className="mb-0">{t("table.ltlOrder")}</p>
                                                                            </div>
                                                                        </Col>
                                                                    }
                                                                    {hasAlert('substitutions') &&
                                                                        <Col sm={12}>
                                                                            <div className="icons-row alert-noti substitute-noti text-left">
                                                                                <span className="svg-holder small-svg">
                                                                                    <img className="red-filter" src={"../../../Images/substitute.svg"} alt="Substitute"></img>
                                                                                </span>

                                                                                <p className="mb-0">{t("table.substitutionOrder")}</p>
                                                                            </div>
                                                                        </Col>
                                                                    }
                                                                    {hasAlert('packageBuilt') &&
                                                                        <Col sm={12}>
                                                                            <div className="icons-row alert-noti bo-noti text-left">
                                                                                <span className="svg-holder small-svg">
                                                                                    <img src="../../../Images/backorder.svg" alt="Alert" />
                                                                                </span>

                                                                                <p className="mb-0">{t("table.packagesBuiltOrder")}</p>
                                                                            </div>
                                                                        </Col>
                                                                    }
                                                                    {hasAlert('backorder') &&
                                                                        <Col sm={12}>
                                                                            <div className="icons-row alert-noti bo-noti text-left">
                                                                                <span className="svg-holder small-svg">
                                                                                    <img src="../../../Images/backorder.svg" alt="Alert" />
                                                                                </span>

                                                                                <p className="mb-0">{t("table.backorderOrder")}</p>
                                                                            </div>
                                                                        </Col>
                                                                    }
                                                                    {(AccSubtotal + ParSubtotal + OtherSubtotal) > 1000 && isDealer &&
                                                                        <Col sm={12}>
                                                                            <div className="icons-row alert-noti bo-noti text-left">
                                                                                <p className="red mb-0 text-left padding-left-extra">{t("table.airShippingRestriction")}</p>
                                                                            </div>
                                                                        </Col>
                                                                    }
                                                                </Row>
                                                            </div>

                                                            {viewMode === 1 ?
                                                                <>
                                                                    {Array.from(selectedItems.values())
                                                                        .sort((a, b) => (a.item.distitemNbr || '').localeCompare(b.item.distitemNbr || ''))
                                                                        .map((d, index) => {
                                                                        const item = d.item;
                                                                        const restricted = item.recallItemCode === "QR" || item.recallItemCode === "QV";

                                                                        return (
                                                                            <div key={d.item.distitemNbr.replaceAll('-', '').toUpperCase() + '-' + index} className="item-inquiry-item">
                                                                                <Row>
                                                                                    {d.item.factorAlert &&
                                                                                        <Col sm={12}>
                                                                                            <div className="icons-row alert-noti asterisk-noti text-left">
                                                                                                <span className="svg-holder small-svg">
                                                                                                    <img className="asterisk-img white-filter" src={"../../../Images/asterisk.svg"} alt="asterisk"></img>
                                                                                                </span>

                                                                                                <p className="mb-0">{t("table.factorItem")}</p>
                                                                                            </div>
                                                                                        </Col>
                                                                                    }
                                                                                    {d.item.ltl &&
                                                                                        <Col sm={12}>
                                                                                            <div className="icons-row alert-noti ltl-noti text-left">
                                                                                                <span className="svg-holder small-svg">
                                                                                                    <img className="white-filter" src={"../../../Images/LTL.svg"} alt="LTL"></img>
                                                                                                </span>

                                                                                                <p className="mb-0">{t("table.ltlItem")}</p>
                                                                                            </div>
                                                                                        </Col>
                                                                                    }
                                                                                    {d.item.substitutedSKU !== '' &&
                                                                                        <Col sm={12}>
                                                                                            <div className="icons-row substitute-noti alert-noti text-left">
                                                                                                <span className="svg-holder small-svg">
                                                                                                    <img className="white-filter" src={"../../../Images/" + d.item.statusIcon} alt={d.item.statusIcon}></img>
                                                                                                </span>

                                                                                                <p className="mb-0">{t("table.substitutionItem", { subSku: d.item.substitutedSKU, newSku: d.item.distitemNbr })}</p>
                                                                                            </div>
                                                                                        </Col>
                                                                                    }
                                                                                    {d.item.pk &&
                                                                                        <Col sm={12}>
                                                                                            <div className="icons-row alert-noti bo-noti text-left">
                                                                                                <span className="svg-holder small-svg">
                                                                                                    <img className="white-filter" src="../../../Images/backorder.svg" alt="Alert" />
                                                                                                </span>

                                                                                                <p className="mb-0">{t("table.packagesBuiltItem")}</p>
                                                                                            </div>
                                                                                        </Col>
                                                                                    }
                                                                                    {d.item.boCnt > 0 &&
                                                                                        <Col sm={12}>
                                                                                            <div className="icons-row alert-noti bo-noti text-left">
                                                                                                <span className="svg-holder small-svg">
                                                                                                    <img className="white-filter" src="../../../Images/backorder.svg" alt="Alert" />
                                                                                                </span>

                                                                                                <p className="mb-0">{t("table.backorderItem")}</p>
                                                                                            </div>
                                                                                        </Col>
                                                                                    }
                                                                                </Row>

                                                                                <Row>
                                                                                    <Col sm={12}>
                                                                                        <Row className={orderStep === 2 ? "mt-3" : "mt-3 padding-extra-left"}>

                                                                                            <Col sm={7} md={8} lg={8} xl={3} className="text-left">
                                                                                                <Row>
                                                                                                    <Col sm={6} md={4} lg={6} className="no-padding-left align-content-center">
                                                                                                        <Row>
                                                                                                            <Col className="fit-content-width-col">
                                                                                                                {orderStep === 2 &&
                                                                                                                    <Col className="mt-5 text-center padding-left-extra-md">
                                                                                                                        <Form.Check
                                                                                                                            type="checkbox"
                                                                                                                            name="checkedItem"
                                                                                                                            aria-label='Select Item'
                                                                                                                            className="float-left"
                                                                                                                            id={'check' + getSelectedItemKey(d)}
                                                                                                                            checked={checkedItems.has(getSelectedItemKey(d))}
                                                                                                                            onChange={handleSelectItem}
                                                                                                                        />
                                                                                                                    </Col>
                                                                                                                }
                                                                                                            </Col>

                                                                                                            <Col className="no-padding-left mb-1">
                                                                                                                <img src={KImageURL(d.item.distitemNbr, d.addInfo?.img)}
                                                                                                                    onError={({ currentTarget }) => {
                                                                                                                        currentTarget.onerror = null;
                                                                                                                        currentTarget.src = DefaultImage;
                                                                                                                    }}
                                                                                                                    alt="Product"
                                                                                                                    className={d.item.factorAlert || d.item.statusIcon.indexOf('.svg') > -1 || d.item.ltl || d.item.substitutedSKU !== '' || d.item.boCnt > 0 ? "item-image red-border" : "item-image"}>
                                                                                                                </img>
                                                                                                            </Col>
                                                                                                        </Row>

                                                                                                    </Col>

                                                                                                    <Col sm={6} md={6} lg={6} className="no-padding-right">
                                                                                                        <p className={d.item.factorAlert || d.item.statusIcon.indexOf('.svg') > -1 || d.item.ltl || d.item.substitutedSKU !== '' || d.item.boCnt > 0 ? "mb-0 red" : "mb-0"}>{d.addInfo && d.addInfo.itemDesc}</p>
                                                                                                        <p className="mb-0">Item No: {d.item.distitemNbr}</p>
                                                                                                        <div className="icons-row mb-1">
                                                                                                            <span className="svg-holder small-svg">
                                                                                                                <img src={"../../../Images/" + d.item.inventoryTypeIcon} alt={d.item.inventoryTypeIcon} ></img>
                                                                                                            </span>

                                                                                                            {d.item.statusIcon.indexOf('.svg') > -1 ?
                                                                                                                <>|<span className="svg-holder small-svg"><img className="margin-left" src={"../../../Images/" + d.item.statusIcon} alt={d.item.statusIcon}></img></span></> :
                                                                                                                <>|<span className="svg-holder small-svg"><div className={`status-icon ${d.item.statusIcon}`}></div></span></>
                                                                                                            }

                                                                                                            {d.item.boCnt > 0 && <>|<span className="svg-holder small-svg"><img src="../../../Images/backorder.svg" alt="Alert" className="margin-left" /></span></>}

                                                                                                            {d.item.factorAlert &&
                                                                                                                <>|<span className="svg-holder small-svg"><img src="../../../Images/asterisk.svg" alt="asterisk" className="asterisk-img margin-left" /></span></>
                                                                                                            }

                                                                                                            {d.item.ltl &&
                                                                                                                <>|<span className="svg-holder small-svg"><img src="../../../Images/LTL.svg" alt="LTL" className="margin-left" /></span></>
                                                                                                            }
                                                                                                        </div>
                                                                                                    </Col>
                                                                                                </Row>
                                                                                            </Col>

                                                                                            <Col sm={2} md={2} lg={2} xl={1} className="pr-0">
                                                                                                <Row className="g-0">
                                                                                                    <Col sm={12}>
                                                                                                        <FloatingLabel label="Memo" className="mt-1 mb-2" >
                                                                                                            <Form.Control
                                                                                                                id={`memo-${getSelectedItemKey(d)}`}
                                                                                                                type="text"
                                                                                                                placeholder="Memo"
                                                                                                                name="addMemo"
                                                                                                                className={'form-control'}
                                                                                                                disabled={restricted}
                                                                                                                maxLength="7"
                                                                                                                // value={!restricted ? d.item.memo : d.item.vin}
                                                                                                                value={d.item.vin}
                                                                                                                onChange={!restricted && handleMemoChange}
                                                                                                            />
                                                                                                        </FloatingLabel>
                                                                                                    </Col>

                                                                                                    <Col sm={12}>
                                                                                                        {d.addInfo &&
                                                                                                            <Dropdown className="mt-1 mb-2 dropdown-info">
                                                                                                                <Dropdown.Toggle variant="outline-dark" className="" id="details-dropdown">Details</Dropdown.Toggle>

                                                                                                                <Dropdown.Menu>
                                                                                                                    <Dropdown.ItemText><span className="bold">Vehicle Use:</span> {d.addInfo.prodLinesText}</Dropdown.ItemText>
                                                                                                                    <Dropdown.Item><span className="bold">Model Year(s):</span> {d.addInfo.yearString} <span className="underline" onClick={() => handleModelModalShow(d.item.distitemNbr)}>View Models</span></Dropdown.Item>
                                                                                                                    {/*<Dropdown.Item><span className="bold">Eligible Exchange/Return:</span> {d.addInfo.eligibleExchangeReturn}</Dropdown.Item>*/}
                                                                                                                    <Dropdown.Item><span className="bold">Dimensions (LxWxHxG) (In):</span> {d.addInfo.dimentions}</Dropdown.Item>
                                                                                                                    <Dropdown.Item><span className="bold">Weight (lb) / Volume (ci):</span> {d.addInfo.weightVal}</Dropdown.Item>
                                                                                                                </Dropdown.Menu>
                                                                                                            </Dropdown>
                                                                                                        }
                                                                                                    </Col>
                                                                                                </Row>
                                                                                            </Col>

                                                                                            <Col sm={3} md={2} lg={2} xl={1}>
                                                                                                <Table bordered>
                                                                                                    <thead>
                                                                                                        <tr>
                                                                                                            <th className="black-bg">Order <br /> Qty</th>
                                                                                                        </tr>
                                                                                                    </thead>
                                                                                                    <tbody>
                                                                                                        <tr>
                                                                                                            <td>
                                                                                                                {orderStep === 2 ?
                                                                                                                    <Form.Control
                                                                                                                        type="number"
                                                                                                                        id={`qty-${getSelectedItemKey(d)}`}
                                                                                                                        aria-describedby="Order Quantity"
                                                                                                                        disabled={restricted}
                                                                                                                        className={'form-control small-text-field'}
                                                                                                                        onBlur={(e) => !restricted && handleOrderQtyBlur(e, index)}
                                                                                                                        onChange={(e) => !restricted && handleOrderQtyChange(e)}
                                                                                                                        value={localQty[getSelectedItemKey(d)] ?? d.item.qtyOrdered}
                                                                                                                    />
                                                                                                                    :
                                                                                                                    d.item.qty + d.item.boCnt
                                                                                                                }
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    </tbody>
                                                                                                </Table>
                                                                                            </Col>

                                                                                            <Col sm={8} md={9} lg={9} xl={5}>
                                                                                                <Table bordered>
                                                                                                    <thead>
                                                                                                        <tr>
                                                                                                            <th>Avail <br /> Qty</th>
                                                                                                            <th>CA <br /> (L)</th>
                                                                                                            <th>KY <br /> (R)</th>
                                                                                                            <th>TX <br /> (D)</th>
                                                                                                            <th>Pkg <br /> Qty</th>
                                                                                                            {d.item.boCnt > 0 && <th>BO</th>}
                                                                                                            <th>Exc / Rtn</th>
                                                                                                        </tr>
                                                                                                    </thead>
                                                                                                    <tbody>
                                                                                                        <tr>
                                                                                                            <td>{d.item.qty}</td>
                                                                                                            <td>{getStatusIcon(d.item.warehouseAvailColorL)}</td>
                                                                                                            <td>{getStatusIcon(d.item.warehouseAvailColorR)}</td>
                                                                                                            <td>{getStatusIcon(d.item.warehouseAvailColorD)}</td>
                                                                                                            <td>{d.item.whslePkgCnt}</td>
                                                                                                            {d.item.boCnt > 0 && <td>{d.item.boCnt}</td>}
                                                                                                            <td>{d.addInfo.eligibleExchangeReturn}</td>
                                                                                                        </tr>
                                                                                                    </tbody>
                                                                                                </Table>
                                                                                            </Col>

                                                                                            <Col sm={4} md={3} lg={3} xl={2}>
                                                                                                <Table bordered>
                                                                                                    <thead>
                                                                                                        <tr>
                                                                                                            <th>Unit <br /> Price</th>
                                                                                                            <th>Item <br /> Total</th>
                                                                                                        </tr>
                                                                                                    </thead>
                                                                                                    <tbody>
                                                                                                        <tr>
                                                                                                            <td>{FormatCurrency(d.item.dealerPrice)}</td>
                                                                                                            <td>{FormatCurrency(d.item.dealerPrice * (d.item.qty + d.item.boCnt))}</td>
                                                                                                        </tr>
                                                                                                    </tbody>
                                                                                                </Table>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </Col>
                                                                                </Row>
                                                                            </div>
                                                                        )
                                                                    })}

                                                                    <div className="item-inquiry-item padding-extra">
                                                                        <Row>
                                                                            <Col sm={12} className="text-right">
                                                                                <Table size="sm" borderless className="mb-0">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td width="19%"></td>
                                                                                            <td>
                                                                                                {orderStep === 2 &&
                                                                                                    <Button variant="secondary" onClick={updateOrderContent}>
                                                                                                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                                                                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                                                                        </svg>
                                                                                                        UPDATE
                                                                                                    </Button>
                                                                                                }
                                                                                            </td>
                                                                                            <td className="text-right bold" valign="middle">
                                                                                                Total: {FormatCurrency(runningTotal)}
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </Table>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </>
                                                                :
                                                                <div className="order-table">
                                                                    <Table hover responsive className="compact-table">
                                                                        <thead>
                                                                            <tr>
                                                                                {orderStep === 2 && <th></th>}
                                                                                <th>
                                                                                    <Trans
                                                                                        i18nKey="form.Item No"
                                                                                        components={{ sup: <sup /> }}
                                                                                    />
                                                                                </th>
                                                                                <th>{t('form.Description')}</th>
                                                                                <th>{t('form.Type')}</th>
                                                                                <th width="8%">
                                                                                    <Trans
                                                                                        i18nKey="form.Order Qty"
                                                                                        components={{ br: <br /> }}
                                                                                    />
                                                                                </th>
                                                                                <th>
                                                                                    <Trans
                                                                                        i18nKey="form.Avail Qty"
                                                                                        components={{ br: <br /> }}
                                                                                    />
                                                                                </th>
                                                                                <th>CA (L)</th>
                                                                                <th>KY (R)</th>
                                                                                <th>TX (D)</th>
                                                                                <th width="10%">{t('form.Memo')}</th>
                                                                                <th>{t('form.Exc / Rtn')}</th>
                                                                                <th>
                                                                                    <Trans
                                                                                        i18nKey="form.Pkg Qty"
                                                                                        components={{ br: <br /> }}
                                                                                    />
                                                                                </th>
                                                                                <th>
                                                                                    <Trans
                                                                                        i18nKey="form.Bo Qty"
                                                                                        components={{ br: <br /> }}
                                                                                    />
                                                                                </th>
                                                                                <th>
                                                                                    <Trans
                                                                                        i18nKey="form.Unit Price"
                                                                                        components={{ br: <br /> }}
                                                                                    />
                                                                                </th>
                                                                                <th>
                                                                                    <Trans
                                                                                        i18nKey="form.Item Total"
                                                                                        components={{ br: <br /> }}
                                                                                    />
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {Array.from(selectedItems.values())
                                                                                .sort((a, b) => (a.item.distitemNbr || '').localeCompare(b.item.distitemNbr || ''))
                                                                                .map((d, index) => {
                                                                                const item = d.item;
                                                                                const restricted = item.recallItemCode === "QR" || item.recallItemCode === "QV";

                                                                                return (
                                                                                    <Fragment key={d.item.distitemNbr.replaceAll('-', '').toUpperCase() + '-' + index}>
                                                                                        {d.item.factorAlert &&
                                                                                            <tr className="alerts-compact">
                                                                                                <td colSpan="15">
                                                                                                    <div className="icons-row alert-noti asterisk-noti text-left">
                                                                                                        <span className="svg-holder small-svg">
                                                                                                            <img className="asterisk-img white-filter" src={"../../../Images/asterisk.svg"} alt="asterisk"></img>
                                                                                                        </span>

                                                                                                        <p className="mb-0">This item's quantity has been increased to a factor of the package quantity.</p>
                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                        }
                                                                                        {d.item.ltl &&
                                                                                            <tr className="alerts-compact">
                                                                                                <td colSpan="15">
                                                                                                    <div className="icons-row alert-noti ltl-noti text-left">
                                                                                                        <span className="svg-holder small-svg">
                                                                                                            <img className="white-filter" src={"../../../Images/LTL.svg"} alt="LTL"></img>
                                                                                                        </span>

                                                                                                        <p className="mb-0">Your whole order may ship LTL due to restrictions on the highlighted item(s)</p>
                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                        }
                                                                                        {d.item.substitutedSKU !== '' &&
                                                                                            <tr className="alerts-compact">
                                                                                                <td colSpan="15">
                                                                                                    <div className="icons-row substitute-noti alert-noti text-left">
                                                                                                        <span className="svg-holder small-svg">
                                                                                                            <img className="white-filter" src={"../../../Images/" + d.item.statusIcon} alt={d.item.statusIcon}></img>
                                                                                                        </span>

                                                                                                        <p className="mb-0">Item No: {d.item.substitutedSKU} is substituted by Item No: {d.item.distitemNbr}</p>
                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                        }
                                                                                        {d.item.pk &&
                                                                                            <tr className="alerts-compact">
                                                                                                <td colSpan="15">
                                                                                                    <div className="icons-row alert-noti bo-noti text-left">
                                                                                                        <span className="svg-holder small-svg">
                                                                                                            <img className="white-filter" src="../../../Images/backorder.svg" alt="Alert" />
                                                                                                        </span>

                                                                                                        <p className="mb-0">Package built to order</p>
                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                        }
                                                                                        {d.item.boCnt > 0 &&
                                                                                            <tr className="alerts-compact">
                                                                                                <td colSpan="15">
                                                                                                    <div className="icons-row alert-noti bo-noti text-left">
                                                                                                        <span className="svg-holder small-svg">
                                                                                                            <img className="white-filter" src="../../../Images/backorder.svg" alt="Alert" />
                                                                                                        </span>

                                                                                                        <p className="mb-0">This item is backordered</p>
                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                        }
                                                                                        <tr className={d.item.factorAlert || d.item.ltl || d.item.substitutedSKU !== '' || d.item.pk || d.item.boCnt > 0 ? 'red-border min-border' : ''}>
                                                                                            {orderStep === 2 &&
                                                                                                <td>
                                                                                                    <Form.Check
                                                                                                        type="checkbox"
                                                                                                        name="checkedItem"
                                                                                                        aria-label='Select Item'
                                                                                                        id={'check' + getSelectedItemKey(d)}
                                                                                                        checked={checkedItems.has(getSelectedItemKey(d))}
                                                                                                        onChange={handleSelectItem}
                                                                                                    />
                                                                                                </td>
                                                                                            }
                                                                                            <td className={d.item.factorAlert || d.item.ltl || d.item.substitutedSKU !== '' || d.item.pk || d.item.boCnt > 0 ? 'red' : ''}>
                                                                                                {d.item.distitemNbr}
                                                                                            </td>
                                                                                            <td className={d.item.factorAlert || d.item.ltl || d.item.substitutedSKU !== '' || d.item.pk || d.item.boCnt > 0 ? 'red' : ''}>
                                                                                                {d.addInfo && d.addInfo.itemDesc}
                                                                                            </td>
                                                                                            <td>
                                                                                                <span className="svg-holder small-svg">
                                                                                                    <img src={"../../../Images/" + d.item.inventoryTypeIcon} alt={d.item.inventoryTypeIcon} />
                                                                                                </span>
                                                                                            </td>
                                                                                            <td>
                                                                                                {orderStep === 2 ?
                                                                                                    <Form.Control
                                                                                                        type="number"
                                                                                                        id={`qty-${getSelectedItemKey(d)}`}
                                                                                                        aria-describedby="Order Quantity"
                                                                                                        className={'form-control small-text-field'}
                                                                                                        disabled={restricted}
                                                                                                        onBlur={(e) => !restricted && handleOrderQtyBlur(e, index)}
                                                                                                        onChange={(e) => !restricted && handleOrderQtyChange(e)}
                                                                                                        value={localQty[getSelectedItemKey(d)] ?? d.item.qtyOrdered}
                                                                                                    />
                                                                                                    :
                                                                                                    d.item.qty + d.item.boCnt
                                                                                                }
                                                                                            </td>
                                                                                            <td>{d.item.qty}</td>
                                                                                            <td>{getStatusIcon(d.item.warehouseAvailColorL)}</td>
                                                                                            <td>{getStatusIcon(d.item.warehouseAvailColorR)}</td>
                                                                                            <td>{getStatusIcon(d.item.warehouseAvailColorD)}</td>
                                                                                            <td>
                                                                                                <FloatingLabel label={t("textfield.Add Memo")}>
                                                                                                    <Form.Control
                                                                                                        id={`memo-${getSelectedItemKey(d)}`}
                                                                                                        type="text"
                                                                                                        placeholder="Memo"
                                                                                                        name="addMemo"
                                                                                                        disabled={restricted}
                                                                                                        className='form-control'
                                                                                                        maxLength="7"
                                                                                                        // value={!restricted ? d.item.memo : d.item.vin}
                                                                                                        value={d.item.vin}
                                                                                                        onChange={!restricted && handleMemoChange}
                                                                                                    />
                                                                                                </FloatingLabel>
                                                                                            </td>
                                                                                            <td>{d.addInfo.eligibleExchangeReturn}</td>
                                                                                            <td>{d.item.whslePkgCnt}</td>
                                                                                            <td>{d.item.boCnt}</td>
                                                                                            <td>{FormatCurrency(d.item.dealerPrice)}</td>
                                                                                            <td>{FormatCurrency(d.item.dealerPrice * (d.item.qty + d.item.boCnt))}</td>
                                                                                        </tr>
                                                                                    </Fragment>
                                                                                )
                                                                            })}

                                                                            <tr>
                                                                                <td colSpan="4"></td>
                                                                                <td width="9%">
                                                                                    {orderStep === 2 &&
                                                                                        <Button variant="secondary" onClick={updateOrderContent}>
                                                                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                                                            </svg>
                                                                                            UPDATE
                                                                                        </Button>
                                                                                    }
                                                                                </td>
                                                                                <td colSpan={orderStep === 2 ? "8" : "7"}></td>
                                                                                <td className="bold">Total:</td>
                                                                                <td className="bold" valign="middle">
                                                                                    {FormatCurrency(runningTotal)}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </Table>
                                                                </div>
                                                            }
                                                        </div>

                                                        <Row className="mt-3">
                                                            {orderStep === 2 &&
                                                                <>
                                                                    <Col md={12} className="text-right">
                                                                        <Button variant="primary" onClick={() => {
                                                                            if (SelectedOrderType && SelectedOrderType !== '') {
                                                                                /*CheckOrderName(orderStep);*/
                                                                                handleStep3Continue();
                                                                            } else if (localSelectedOrderType && localSelectedOrderType !== '') {
                                                                                setSelectedOrderType(localSelectedOrderType);
                                                                                handleStep3Continue();
                                                                                /*CheckOrderName(orderStep);*/
                                                                            } else {
                                                                                $('#SelectOrderType').addClass('is-invalid');
                                                                            }
                                                                            // if (ItemsNumberQtyArr) {
                                                                            //     SaveOrderIntoTempTable(ItemsNumberQtyArr, 2);
                                                                            // }
                                                                        }}>
                                                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                                            </svg>
                                                                            {t("order.continue")}
                                                                        </Button>
                                                                    </Col>
                                                                </>
                                                            }
                                                        </Row>

                                                        {orderStep === 2 && (localSelectedOrderType === "1" || localSelectedOrderType === "3") && new Date() < new Date(2026, 11, 12) && (window.location.origin.indexOf("kdealer") > -1 || window.location.origin.indexOf("k-dealer") > -1 || window.location.origin.indexOf("localhost") > -1) &&
                                                            <Col sm={12} className="mt-3">
                                                                <div className="gray-border gray-bg">
                                                                    <div className="padding-div">
                                                                        <Row>
                                                                            <Col sm={6}>
                                                                                <h4 className="bold">WINTER ACCESSORY PROGRAM</h4>
                                                                                <p className="mb-0">
                                                                                    Program Dates: <span className="red">September 19 - December 11, 2026</span> <br />
                                                                                    Up to <span className="bold"><span className="red">12% Discount</span> (+K-Loyalty Rewards)</span> <br />
                                                                                    Schedule out orders through February 2027 (Contact your P&A Sales Representative) <br />
                                                                                    ICHIBAN Performance Plus qualifier
                                                                                </p>
                                                                            </Col>

                                                                            <Col sm={6}>
                                                                                <p className="mb-0">
                                                                                    Orders can be processed through your Kawasaki P&A Sales Representatives or through K-Dealer using one of the provided K-codes.
                                                                                    Don't miss out: Place your order today, to take advantage of these great
                                                                                    benefits! <br /> <a href="https://www.k-dealer.com/formrepository/Forms/PA26-26%20Winter%20Accessory%20Program.pdf" target="_blank" rel="noreferrer">Click here to review the program bulletin.</a>
                                                                                </p>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        }
                                                    </>
                                                :
                                                    <Row>
                                                        <Col sm={12} className="text-center">
                                                            <p className="bold mt-5 mb-4 svg-carat">
                                                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                                    <path transform="rotate(-90 8 8)" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                                </svg>
                                                                {t('Order.Add item(s) above to begin your order')}
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                }
                                            </>
                                        : orderStep === 1 &&
                                            <Row>
                                                <Col sm={12} className="text-center">
                                                    <p className="bold mt-5 mb-5 svg-carat">
                                                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                            <path transform="rotate(-90 8 8)" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                        </svg>
                                                        Select an Order {userInfo?.loginType !== 5 ? 'Type' : 'Name'} above to get started
                                                    </p>
                                                </Col>
                                            </Row>
                                        }
                                    </Card.Body>
                                </Card>

                                <div id="step-2-start">
                                    {orderStep === 3 &&
                                        <>
                                            <Row>
                                                <Col sm={12}>
                                                    <Card className="mb-3">
                                                        <Card.Body>
                                                            <Row>
                                                                <Col sm={12}>
                                                                    <Card.Title className="vertical-line heading card-main-title active-heading" role="heading">
                                                                        <span className="smaller-text heading">{t("order.step3")} </span>{t("order.orderReview")}
                                                                    </Card.Title>
                                                                </Col>
                                                            </Row>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            </Row>

                                            {Total && SelectedOrderType === "3" && userInfo?.loginType !== 5 &&
                                                <Row>
                                                    <Col sm={12}>
                                                        <Card className="mb-3">
                                                            <Card.Body>
                                                                <Row>
                                                                    <Col sm={12}>
                                                                        <Card.Title className="vertical-line heading" role="heading">K-CODE</Card.Title>
                                                                    </Col>

                                                                    <Col sm={6}>
                                                                        <div className="black-bg padding-extra">
                                                                            <p className="white">Please review current program bulletins for available K-Codes:</p>
                                                
                                                                            {standardPromoCodes && standardPromoCodes.length > 0 &&
                                                                                <p className="white">
                                                                                    {standardPromoCodes.map((item, index) => (
                                                                                        <span key={item + index} className="green-text confirmation-text">{item}</span>
                                                                                    ))}
                                                                                    : Standard Terms
                                                                                </p>
                                                                            }

                                                                            {extendedPromoCodes && extendedPromoCodes.length > 0 &&
                                                                                <p className="white">
                                                                                    {extendedPromoCodes.map((item, index) => (
                                                                                        <span key={item + index} className="green-text confirmation-text">{item}</span>
                                                                                    ))}
                                                                                    : Extended Terms
                                                                                </p>
                                                                            }
                                                                        </div>
                                                                    </Col>

                                                                    <Col sm={6}>
                                                                        {appliedKCode ?
                                                                            <div className="green-border padding-extra h-100">
                                                                                <Row className="mt-3">
                                                                                    <Col sm={6}>
                                                                                        <h4 className="green-text bold heading uppercase">{appliedKCode}</h4>
                                                                                        <p className="bold">K-Code Applied</p>
                                                                                    </Col>
                                                                                    <Col sm={6} className="text-right">
                                                                                        <Button variant="secondary" onClick={() => { setAppliedKCode(''); setKCode(''); }}>
                                                                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                                                            </svg>
                                                                                            EDIT
                                                                                        </Button>
                                                                                    </Col>
                                                                                </Row>
                                                                            </div>
                                                                            :
                                                                            <Row>
                                                                                <Col sm={12}>
                                                                                    <p className="bold mt-1">If you are ordering with a K-Code, you can enter it here:</p>
                                                                                </Col>

                                                                                <Col md={8} xl={9} xxl={10}>
                                                                                    <FloatingLabel label="Enter your K-Code" className="mb-3">
                                                                                        <Form.Control id="kCode" type="text" placeholder="Enter your K-Code" value={kCode} className={'form-control'} onChange={handleChange} name="kCode" maxLength={50} />
                                                                                    </FloatingLabel>
                                                                                </Col>

                                                                                <Col md={4} xl={3} xxl={2} className="mt-1 text-right">
                                                                                    <Button variant="secondary" onClick={handleAddKCode}>
                                                                                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                                                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                                                        </svg>
                                                                                        APPLY
                                                                                    </Button>
                                                                                </Col>
                                                                            </Row>
                                                                        }
                                                                    </Col>

                                                                    {new Date() < new Date(2026, 11, 12) &&
                                                                        <Col sm={12} className="mt-3">
                                                                            <div className="gray-border gray-bg" id="kCodeTerms">
                                                                                <div className="padding-div">
                                                                                    <Row>
                                                                                        <Col sm={6}>
                                                                                            <h4 className="bold">WINTER ACCESSORY PROGRAM</h4>
                                                                                            <p className="mb-0">
                                                                                                Program Dates: <span className="red">September 19 - December 11, 2026</span> <br />
                                                                                                Up to <span className="bold"><span className="red">12% Discount</span> (+K-Loyalty Rewards)</span> <br />
                                                                                                Schedule out orders through February 2027 (Contact your P&A Sales Representative) <br />
                                                                                                ICHIBAN Performance Plus qualifier
                                                                                            </p>
                                                                                        </Col>

                                                                                        <Col sm={6}>
                                                                                            <p className="mb-0">
                                                                                                Orders can be processed through your Kawasaki P&A Sales Representatives or through K-Dealer using one of the provided K-codes.
                                                                                                Don't miss out: Place your order today, to take advantage of these great
                                                                                                benefits! <br /> <a href="https://www.k-dealer.com/formrepository/Forms/PA26-26%20Winter%20Accessory%20Program.pdf" target="_blank" rel="noreferrer">Click here to review the program bulletin.</a>
                                                                                            </p>
                                                                                        </Col>
                                                                                    </Row>
                                                                                </div>
                                                                            </div>
                                                                        </Col>
                                                                    }
                                                                </Row>
                                                            </Card.Body>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            }

                                            <Row className="d-flex gy-3 mb-4">
                                                <Col md={8}>
                                                    <Card className="mb-3 h-100">
                                                        <Card.Body>
                                                            <Row>
                                                                <Col sm={6}>
                                                                    <Card.Title className="vertical-line heading" role="heading">{t("order.shipTo")} <span className="smaller-text underline" onClick={handleDealerModalShow}>{t("order.changeDealer")}</span></Card.Title>
                                                                    {ShipTo &&
                                                                        <p className="m-t-md">{ShipTo.firstName} <br />
                                                                            {ShipTo.address} <br />
                                                                            {ShipTo.cityStateZip} <br />
                                                                            {ShipTo.countryCode}
                                                                        </p>
                                                                    }

                                                                    {uniqueDealer && selectedShipItem?.shipMethodName?.toLowerCase().startsWith("3rd party") &&
                                                                        <Row>
                                                                            <Col sm={10}>
                                                                                <FloatingLabel label="Enter 3rd Party Account Number" className="mt-2 mb-2">
                                                                                    <Form.Control id="thirdParty" type="text" placeholder="Enter 3rd Party Account Number" value={thirdParty} className={'form-control'} onChange={handleChange} name="thirdParty" maxLength={10} />
                                                                                </FloatingLabel>
                                                                            </Col>
                                                                        </Row>
                                                                    }
                                                                </Col>

                                                                <Col sm={6} className="text-left">
                                                                    <Card.Title className="vertical-line heading" role="heading">{t("order.shipMethod")}</Card.Title>

                                                                    <Row className="m-t-md">
                                                                        <Col sm={12}>
                                                                            <Form.Select id="SelectShipMethod" aria-label="Select Ship Method" value={ShipMethod} onChange={(e) => { ChangeShipMethod(e.target.value) }}>
                                                                                {ShipCodes ?
                                                                                    ShipCodes.map((item) => (
                                                                                        <option value={item.shipCode} key={item.shipCode}>{item.shipMethodName}</option>
                                                                                    ))
                                                                                :
                                                                                    <option value={""}>Shipping methods unavailable at this time, please try again later.</option>
                                                                                }
                                                                            </Form.Select>

                                                                            {(localSelectedOrderType === '4' || SelectedOrderType === '4' || (userInfo?.loginType === 5 && (SelectedForwarderAddress || SelectedDropshipAddress))) &&
                                                                                <>
                                                                                    <Card.Title className="heading mt-4" role="heading">Forwarder/Dropship Address Information:</Card.Title>

                                                                                    {SelectedForwarderAddress &&
                                                                                        <Row className="m-t-md">
                                                                                            <Col sm={12}>
                                                                                                <Form.Select id="SelectForwarderAdd" aria-label="Select Forwarder Address" value={ForwarderAdd} onChange={(e) => ChangeForwarderAddress(e.target.value)}>
                                                                                                    <option value=''>Select Forwarder Address</option>
                                                                                                    {SelectedForwarderAddress.map((item) => (
                                                                                                        <option value={item.carrCode} key={item.carrCode}>
                                                                                                            {item.crrName + ' ' + item.add + ' ' + item.city + ' ' + item.stateCode + ' ' + item.zip}
                                                                                                        </option>
                                                                                                    ))}
                                                                                                </Form.Select>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    }

                                                                                    <Row className={dropShipValidator ? "invalid-section m-t-md" : "m-t-md"}>
                                                                                        {userInfo?.dealerID === "0336" &&
                                                                                            <Col sm={12}>
                                                                                                <Form.Check
                                                                                                    type="checkbox"
                                                                                                    name="manualDropShip"
                                                                                                    aria-label='Enter dropship address manually'
                                                                                                    label="Enter dropship address manually"
                                                                                                    checked={manualDropShip}
                                                                                                    onChange={handleChange}
                                                                                                    className="mb-2"
                                                                                                />
                                                                                            </Col>
                                                                                        }

                                                                                        {!manualDropShip &&
                                                                                            <Col sm={12}>
                                                                                                <Select
                                                                                                    id="SelectDropShipAdd"
                                                                                                    placeholder={<div>Enter Dropship Address</div>}
                                                                                                    options={formatDropShip}
                                                                                                    isLoading={!SelectedDropshipAddress}
                                                                                                    loadingMessage={() => "Loading addresses..."}
                                                                                                    noOptionsMessage={() =>
                                                                                                        dealersLoading
                                                                                                            ? "Loading addresses..."
                                                                                                            : "No addresses found"
                                                                                                    }
                                                                                                    isSearchable
                                                                                                    isClearable
                                                                                                    onChange={(option) => ChangeDropShipAddress(option ? option.value : "")}
                                                                                                />

                                                                                                {selectedDropShip &&
                                                                                                    <div className="gray-bg padding-extra mt-3">
                                                                                                        <p className="mb-0">
                                                                                                            {selectedDropShip.crrName + ' ' + selectedDropShip.add + ' ' + selectedDropShip.city + ' ' + selectedDropShip.stateCode + ' ' + selectedDropShip.zip}
                                                                                                        </p>
                                                                                                    </div>
                                                                                                }
                                                                                            </Col>
                                                                                        }
                                                                                    </Row>
                                                                                </>
                                                                            }
                                                                        </Col>
                                                                    </Row>

                                                                </Col>
                                                            </Row>

                                                            {manualDropShip &&
                                                                <Row>
                                                                    <Col sm={12}>
                                                                        <Card.Title className="heading mt-3" role="heading">Enter Dropship Address:</Card.Title>
                                                                    </Col>
                                                                    <Col sm={6}>
                                                                        <FloatingLabel label="Name*" className="mt-2 mb-2">
                                                                            <Form.Control id="dName" type="text" placeholder="Address" value={dropShipCrrName} className={'form-control'} onChange={handleChange} name="dripShipName" />
                                                                        </FloatingLabel>
                                                                    </Col>
                                                                    <Col sm={6}>
                                                                        <FloatingLabel label="Address*" className="mt-2 mb-2">
                                                                            <Form.Control id="dAddress1" type="text" placeholder="Address" value={dropShipAddress} className={'form-control'} onChange={handleChange} name="dropShipAddress" />
                                                                        </FloatingLabel>
                                                                    </Col>
                                                                    <Col sm={6}>
                                                                        <FloatingLabel label="Address 2" className="mt-2 mb-2">
                                                                            <Form.Control id="dAddress2" type="text" placeholder="Address" value={dropShipAddress2} className={'form-control'} onChange={handleChange} name="dropShipAddress2" />
                                                                        </FloatingLabel>
                                                                    </Col>
                                                                    <Col sm={6}>
                                                                        <FloatingLabel label="City*" className="mt-2 mb-2">
                                                                            <Form.Control id="dCity" type="text" placeholder="City" value={dropShipCity} className={'form-control'} onChange={handleChange} name="dropShipCity" />
                                                                        </FloatingLabel>
                                                                    </Col>
                                                                    <Col sm={6}>
                                                                        <FloatingLabel label="State*" className="mt-2 mb-2">
                                                                            <Form.Select id="dState" aria-label="Select a state" value={dropShipState} name="dropShipState" onChange={handleChange}>
                                                                                <option value="">Select a state</option>
                                                                                {stateOptions.map(op => (
                                                                                    <><option value={op.value}>{op.label}</option></>
                                                                                ))}
                                                                            </Form.Select>
                                                                        </FloatingLabel>
                                                                    </Col>
                                                                    <Col sm={6}>
                                                                        <FloatingLabel label="Zip Code*" className="mt-2 mb-2">
                                                                            <Form.Control id="dZip" type="text" placeholder="Zip Code" value={dropShipZipCode} className={'form-control'} onChange={handleChange} name="dropShipZipCode" />
                                                                        </FloatingLabel>
                                                                    </Col>
                                                                </Row>
                                                            }

                                                            {userInfo?.loginType !== 5 &&
                                                                <Row className="mt-4">
                                                                    <Col sm={6}>
                                                                        <Table responsive bordered className="table-center black-heading">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>ORDER TIME</th>
                                                                                    <th>LIKELIHOOD <span className="green-text">SAME-DAY</span> <br />ORDER PROCESSING</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td>8:00 am - 12:00 pm</td>
                                                                                    <td className="table-row center-exclude"><div className="status-icon green-icon"></div> High</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>12:01 pm - 2:00 pm</td>
                                                                                    <td className="table-row center-exclude"><div className="status-icon yellow-icon"></div> Moderate</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>2:01 pm - 5:00 pm</td>
                                                                                    <td className="table-row center-exclude"><div className="status-icon red-icon"></div> Low</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </Table>

                                                                        <p>Note: This is an estimate and not a guarantee of service.</p>
                                                                    </Col>

                                                                    <Col sm={6}>
                                                                        <p>Likelihood order processes SAME DAY as received by hour at your primary distribution center.</p>
                                                                        <h5>Shipping Information</h5>
                                                                        <p>
                                                                            KMC routing guides determine LTL weight and volume breaks. Collective weight or dimension of a single inventory item or a collective
                                                                            order may change shipping type to LTL without notice and will be charged the appropriate freight amount unless free freight threshold
                                                                            is met.
                                                                        </p>
                                                                    </Col>
                                                                </Row>
                                                            }
                                                        </Card.Body>
                                                    </Card>
                                                </Col>

                                                <Col md={4}>
                                                    <Card className="summary-card mb-0 h-100">
                                                        <Card.Body>
                                                            <Row className="title-group summary-title keep-layout checkout-title-row">
                                                                <Col className="checkout-title">
                                                                    <Card.Title className="vertical-line heading" role="heading">{t("order.orderSummary")}</Card.Title>
                                                                </Col>
                                                            </Row>

                                                            <Row>
                                                                <Col sm={12}>
                                                                    <div className="black-card-heading">
                                                                        <p className="mb-0 heading">ITEM SUBTOTAL</p>
                                                                    </div>
                                                                </Col>
                                                            </Row>

                                                            <Row className="keep-layout">
                                                                <Col lg={6} md={8} sm={6}>
                                                                    <p>{t("order.partsSubtotal")}</p>
                                                                </Col>
                                                                <Col lg={6} md={4} sm={6}>
                                                                    <p className="right-text heading" id="partsSubtotal">{FormatCurrency(ParSubtotal)}</p>
                                                                </Col>
                                                            </Row>
                                                            <Row className="keep-layout">
                                                                <Col lg={6} md={8} sm={6}>
                                                                    <p>{t("order.accessoriesSubtotal")}</p>
                                                                </Col>
                                                                <Col lg={6} md={4} sm={6}>
                                                                    <p className="right-text heading" id="accSubtotal">{FormatCurrency(AccSubtotal)}</p>
                                                                </Col>
                                                            </Row>
                                                            <Row className="keep-layout">
                                                                <Col lg={6} md={8} sm={6}>
                                                                    <p className="mb-0">{t("order.otherSubtotal")}</p>
                                                                </Col>
                                                                <Col lg={6} md={4} sm={6}>
                                                                    <p className="right-text heading mb-0" id="otherSubtotal">{FormatCurrency(OtherSubtotal)}</p>
                                                                </Col>
                                                            </Row>

                                                            <hr></hr>
                                                            <Row>
                                                                <Col sm={12} className="text-right">
                                                                    <p className="right-text heading mb-0" id="itemSubtotal">{FormatCurrency(ParSubtotal + AccSubtotal + OtherSubtotal)}</p>
                                                                </Col>
                                                            </Row>
                                                            <hr></hr>

                                                            <Row>
                                                                <Col sm={12}>
                                                                    <div className="black-card-heading mt-1">
                                                                        <p className="mb-0 heading">ESTIMATED FREIGHT AND HANDLING</p>
                                                                    </div>
                                                                </Col>
                                                            </Row>

                                                            <Row className="keep-layout">
                                                                <Col lg={6} md={8} sm={6}>
                                                                    <p>{t("order.estFreight")}</p>
                                                                </Col>
                                                                <Col lg={6} md={4} sm={6}>
                                                                    <p className="right-text heading" id="freight">{SpecialDealerFeeText ? SpecialDealerFeeText : FormatCurrency(EstFreight)}</p>
                                                                </Col>
                                                            </Row>
                                                            <Row className="keep-layout">
                                                                <Col lg={6} md={8} sm={6}>
                                                                    <p>{t("order.estHandling")}</p>
                                                                </Col>
                                                                <Col lg={6} md={4} sm={6}>
                                                                    <p className="right-text heading" id="handling">{FormatCurrency(EstHandling)}</p>
                                                                </Col>
                                                            </Row>
                                                            <Row className="keep-layout">
                                                                <Col lg={6} md={8} sm={6}>
                                                                    <p className="mb-0">{t("order.estSpecialFee")}</p>
                                                                </Col>
                                                                <Col lg={6} md={4} sm={6}>
                                                                    <p className="right-text heading mb-0" id="specialFee">{FormatCurrency(EstSpecialFee)}</p>
                                                                </Col>
                                                            </Row>

                                                            {/*<Row className="keep-layout">*/}
                                                            {/*     {Total && SelectedOrderType === "3" && */}
                                                            {/*         <><Col lg={6} md={8} sm={6}>*/}
                                                            {/*             <p>K-Code</p>*/}
                                                            {/*         </Col>*/}
                                                            {/*         <Col lg={6} md={4} sm={6}>*/}
                                                            {/*             <p className="right-text underline no-click" id="promoCode">{appliedKCode}</p>*/}
                                                            {/*         </Col></>*/}
                                                            {/*    }*/}
                                                            {/*</Row>*/}

                                                            <hr></hr>
                                                            <Row>
                                                                <Col sm={12}>
                                                                    <p className="right-text heading mb-0">{FormatCurrency(EstFreight + EstHandling + EstSpecialFee)}*</p>
                                                                </Col>
                                                            </Row>
                                                            <hr></hr>

                                                            <p className="red">*Freight and Handling are estimates. K-Loyalty Freight and Discounts will be applied on your final invoice.</p>

                                                            {submitErrorMsg &&
                                                                <>
                                                                    <Row className="title-group summary-title">
                                                                        <Col sm={12}>
                                                                            <Card.Title className="red heading">{submitErrorMsg}</Card.Title>
                                                                        </Col>
                                                                    </Row>
                                                                    <hr></hr>
                                                                </>
                                                            }

                                                            {IsTestDealer(userInfo?.dealerID) !== true &&                                                                 <Row>
                                                                    <Col sm={12} className="text-right">
                                                                        <Button controlid='btnContinue' variant="primary" className="submit mb-0" onClick={() => SubmitOrder(false)}>
                                                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                                            </svg>
                                                                            {t("order.submit")}
                                                                        </Button>
                                                                    </Col>
                                                                </Row>
                                                            }
                                                                
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </>
                                    }
                                </div>
                            </>
                            :
                            <>
                                <Card className="mb-3">
                                    <Card.Body>
                                        <Row>
                                            <Col className="text-center">
                                                <h1 className="vertical-line heading confirmation-heading">{t("order.thankYou")}</h1>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm={12} className="text-center">
                                                {creditHold === true &&
                                                    <h3 className="red">This order requires credit department approval before being shipped. <br /> Please contact your area credit supervisor.</h3>
                                                }

                                                {OrderID !== '' ?
                                                    <h3 className="heading order-confirmation confirmation-heading mb-4">
                                                        {t("order.orderNumber")} <span className="underline green-text" onClick={() => handleClickOrderID()}>{OrderID && OrderID}</span>
                                                    </h3>
                                                :
                                                    <h3 className="heading order-confirmation confirmation-heading mb-4">
                                                        Your order has been placed, you will receive a confirmation with your order # shortly.
                                                    </h3>
                                                }

                                                {waitMsg === true &&
                                                    <p>Please allow 3-5 minutes for your order to be reflected on the Order Status page.</p>
                                                }

                                                <p>{t("order.confirmationEmail")}</p>
                                                <p>{t("order.thanksMessage")}</p>

                                                {/*<Button variant="secondary" onClick={() => tryPrint()}>*/}
                                                {/*    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">*/}
                                                {/*        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />*/}
                                                {/*    </svg>*/}
                                                {/*    PRINT FOR YOUR RECORDS*/}
                                                {/*</Button>*/}
                                            </Col>
                                        </Row>

                                        {orderSaved &&
                                            <Row className="justify-content-center">
                                                <Col sm={6} className="gray-border gray-bg text-center">
                                                    <div className="padding-extra">
                                                        <p>You have saved items from your prior order.</p>

                                                        <Button variant="tertiary"
                                                            onClick={() => {
                                                                resumeSavedOrder();
                                                            }}
                                                        >
                                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                            </svg>
                                                            CONTINUE WITH SAVED ORDER
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        }

                                        <Row className="mt-5">
                                            <Col sm={4} className="text-right">
                                                <Button variant="secondary" onClick={() => navigate("/orderhistory")}>
                                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                    </svg>
                                                    {t("order.orderHistory")}
                                                </Button>
                                            </Col>

                                            <Col sm={4} className="text-center">
                                                {!orderSaved &&
                                                    <Button variant="tertiary"
                                                        onClick={() => {
                                                            setOrderStep(1);
                                                            clearCart();
                                                            setSelectedItems(new Map());
                                                            setChangedSKU(null);
                                                            setOrderName('');
                                                            setThirdParty('');
                                                            setSelectedDropShip(null);
                                                            setLocalSelectedOrderType('');
                                                            setSelectedOrderType('')
                                                            setSubmit(false);
                                                            setOrderSaved(false);
                                                            window.location.reload();
                                                        }}
                                                    >
                                                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                        </svg>
                                                        {t("order.newOrder")}
                                                    </Button>
                                                }
                                            </Col>

                                            <Col sm={4} className="text-left">
                                                <Button controlid='btnContinue' variant="primary" className="submit" onClick={() => { userInfo?.loginType !== 5 ? navigate("/dealerhome") : navigate("/kcountrieshome") }}>
                                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                    </svg>
                                                    {t("order.homepage")}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </>
                        }

                    </Col>
                </Row>
            </Container>

            <FooterDealer />

            <Modal className="loader-div" id="loader" show={pop} onHide={handleClosePop} size="lg" centered backdrop="static" keyboard={false}>
                <PulseLoader color="#66cc33" size="20px" margin="12px" />
            </Modal>

            <Modal show={showDealerModal} onHide={handleDealerModalClose} dialogClassName="dealer-section" centered backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{t("order.changeDealerTitle")}</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" className="btn-close-sibling" />
                </Modal.Header>

                <Modal.Body>
                    <Row>
                        <Col sm={12} className="text-left">
                            <Select
                                id="selectDealerID"
                                placeholder={<div>Dealer ID/Name</div>}
                                options={formattedDealerAddresses}
                                isLoading={dealersLoading}
                                loadingMessage={() => "Loading dealers..."}
                                noOptionsMessage={() =>
                                    dealersLoading
                                        ? "Loading dealers..."
                                        : "No dealers found"
                                }
                                isSearchable
                                isClearable
                                onChange={(option) => changeDealerID(option ? option : "")}
                            />
                        </Col>
                    </Row>
                </Modal.Body>

                <Modal.Footer className="text-right">
                    <Button variant="primary" onClick={() => ChangeDealer()}>
                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                        </svg>
                        {t("order.saveDealer")}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showModelModal} onHide={handleModelModalClose} backdrop="static" centered dialogClassName="dealer-section model-window">
                <Modal.Header closeButton style={{ justifyContent: 'center' }}>
                    <Modal.Title>{t("order.models")}</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" className="btn-close-sibling" />
                </Modal.Header>
                <Modal.Body>
                    {!Models ?
                        <PulseLoader color="#66cc33" size="20px" margin="12px" className="mt-5" />
                        :
                        <Table bordered hover striped>
                            <thead>
                                <tr>
                                    <td colSpan="3">{SelectedItemForModels && SelectedItemForModels.itemNum}, {SelectedItemForModels && SelectedItemForModels.itemName}</td>
                                </tr>
                                {Models.length > 0 && <tr>
                                    <td colSpan="3">{t("order.itemFitsModels")}</td>
                                </tr>}

                            </thead>
                            <tbody>
                                {Models.length > 0 ? Models.map((d) =>
                                    <>
                                        {d.models.map((m) =>
                                            <tr>
                                                <td>{m.year}</td>
                                                <td>{m.label}</td>
                                                <td>{m.value}</td>
                                            </tr>)}
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </>

                                ) :
                                    <tr>{t("order.noModelRestrictions")}</tr>
                                }
                            </tbody>

                        </Table>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModelModalClose}>
                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                        </svg>
                        {t("notice.close")}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showQtyModal} onHide={handleQtyModalClose} dialogClassName="dealer-section" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t("order.invalidQtyTitle")}</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" className="btn-close-sibling" />
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                            <p>{t("order.invalidQtyMessage")}</p>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

            <Modal show={showDeleteModal} onHide={handleDeleteModalClose} dialogClassName="dealer-section" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t("order.deleteItem")}</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" className="btn-close-sibling" />
                </Modal.Header>
                {checkedItems.size > 0 ?
                    <>
                        <Modal.Body>
                            <Row>
                                <Col sm={12}>
                                    <p>{t("order.confirmRemoveItems")}</p>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer style={{ display: 'block' }}>
                            <Row>
                                <Col sm={6} className="text-right">
                                    <Button variant="secondary" onClick={handleDeleteModalClose}>
                                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                        </svg>
                                        {t("order.cancel")}
                                    </Button>
                                </Col>
                                <Col sm={6} className="text-left">
                                    <Button variant="primary" onClick={DeleteSelectedItems}>
                                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                        </svg>
                                        {t("order.remove")}
                                    </Button>
                                </Col>
                            </Row>
                        </Modal.Footer>
                    </>
                    :
                    <>
                        <Modal.Body>
                            <Row>
                                <Col sm={12}>
                                    <p>{t("order.selectItemToDelete")}</p>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Row>
                                <Col sm={12} className="text-right">
                                    <Button variant="secondary" onClick={handleDeleteModalClose}>
                                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                        </svg>
                                        {t("notice.close")}
                                    </Button>
                                </Col>
                            </Row>
                        </Modal.Footer>
                    </>
                }
            </Modal>

            <Modal show={popUpModal} onHide={handlePopUpModalClose} dialogClassName="dealer-section" centered scrollable>
                <Modal.Header closeButton>
                    <Modal.Title>{t("notice.title")}</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" className="btn-close-sibling" />
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                            {invalidKCodeSKUList ?
                                <h4 className="header bold mb-3">{popUpErrorMsg}</h4>
                                :
                                <p>{popUpErrorMsg}</p>
                            }
                        </Col>
                        {invalidKCodeSKUList &&
                            <Col sm={12}>
                                <p className="text-left">
                                    The items listed below are not eligible for the K-Code that was entered. Items must either be removed from the order, or processed as a separate order.
                                </p>
                                <ul className="text-left">
                                    {invalidKCodeSKUList.map((item, index) => (
                                        <li key={index}>{item.value}, {item.label}</li>
                                    ))}
                                </ul>
                            </Col>
                        }
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        {invalidKCodeSKUList ?
                            <>
                                <Col sm={12} className="text-left border-top">
                                    <p className="bold text-center">Please select an option</p>
                                    <Form.Check
                                        label="Remove Ineligible Items from this order and add them to a new Saved Order (you will be able to resume this saved order upon completion of the current order)"
                                        name="kcode-radio"
                                        type="radio"
                                        id="radio-k-code-1"
                                        value={"1"}
                                        checked={kCodeRadio === "1"}
                                        onChange={(e) => setKCodeRadio(e.target.value)}
                                    />
                                    <Form.Check
                                        label="Remove Ineligible Items and proceed with qualifying Items only"
                                        name="kcode-radio"
                                        type="radio"
                                        id="radio-k-code-2"
                                        value={"2"}
                                        checked={kCodeRadio === "2"}
                                        onChange={(e) => setKCodeRadio(e.target.value)}
                                    />
                                    <Form.Check
                                        label="Remove K-Code and proceed with all Items"
                                        name="kcode-radio"
                                        type="radio"
                                        id="radio-k-code-3"
                                        value={"3"}
                                        checked={kCodeRadio === "3"}
                                        onChange={(e) => setKCodeRadio(e.target.value)}
                                    />
                                </Col>

                                <Col sm={12} className="text-center mt-3">
                                    <Button variant="primary" onClick={handleKCodeSave}>
                                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                        </svg>
                                        CONTINUE
                                    </Button>
                                </Col>
                            </>
                            :
                            <Col sm={12} className="text-center">
                                <Button variant="secondary" onClick={handlePopUpModalClose}>
                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                    </svg>
                                    {t("notice.close")}
                                </Button>
                            </Col>
                        }
                    </Row>
                </Modal.Footer>
            </Modal>

            <FileUpload show={importDealerModal} handleClose={handleImportModalClose} SendSKUQtyToItemInquiry={SendSKUQtyToItemInquiry} />

            <ItemInquiry show={showItemModal} handleClose={handleItemModalClose} handleSelectedItems={fromImport ? handleBulkImportSelectedItems : handleSelectedItems} orderType={SelectedOrderType ?? null} setOrderType={setOrderType} autoSubmit={false} bulkLoadData={BulkLoad} fromImport={fromImport} />

        </>
    );
}
